<template>
  <div class="client">   
    <v-card
      flat
      class="rounded-xl"
    >
      <v-card-title class="text-center justify-center py-6">
        <h1
          v-if="updatedClient.full_name && $store.state.loadingApp === 0"
          class="font-weight-bold display-1 grey--text"
        >
          {{ updatedClient.full_name }}
        </h1>
        <h1
          v-else
          class="font-weight-bold display-1 grey--text"
        >
          waiting..
        </h1>
      </v-card-title>
      <v-card-actions>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-chip
              small
              class="ppc_darkgreen white--text ml-2"
              v-on="on"
            >
              {{ formattedDate(updatedClient.start_first) }}
              <v-icon
                small
                class="ml-1 white--text"
              >
                fa-plane-arrival
              </v-icon>
            </v-chip>
          </template>
          <span>Start date</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-chip
              small
              class="ppc_darkgreen white--text ml-2"
              v-on="on"
            >
              {{ formattedDate(updatedClient.end_last) }}
              <v-icon
                small
                class="ml-1 white--text"
              >
                fa-plane-departure
              </v-icon>
            </v-chip>
          </template>
          <span>End date</span>
        </v-tooltip>
        <v-spacer />
        <!-- <span v-if="updatedClient.statusClientId === 8 || updatedClient.statusClientId === 9">
          <v-chip 
            @click='resetStatusClient'
            small
          >
           reset status
          </v-chip>
        </span> -->
        <span>
          <v-chip 
            v-if="getStatusClient(updatedClient.statusClientId)" 
            class="mx-4" 
            :color="`${getStatusClient(updatedClient.statusClientId).color}`" 
            text-color="white"
            v-html="`${getStatusClient(updatedClient.statusClientId).name}`"
          />
        </span>
        <!-- =>
        <span>
          <v-chip 
            v-if="getStatusClient(updatedClient.statusClientIdNew)" 
            class="mx-4" 
            :color="`${getStatusClient(updatedClient.statusClientIdNew).color}`" 
            text-color="white"
            v-html="`${getStatusClient(updatedClient.statusClientIdNew).name}`">
          </v-chip>
        </span> -->
        <v-btn
          v-if="calcPMmessages > 0"
          color="ppc_pink"
          small
          rounded
          class="mr-12"
          @click="$router.push({ name: 'PackageMaker' })"
        >
          <dir class="ml-1 white--text">
            {{ calcPMmessages }}
          </dir>
          <v-icon
            small
            class="mx-1 white--text"
          >
            $vuetify.icons.icon_mdi_package_variant
          </v-icon> 
        </v-btn>
      </v-card-actions>
  
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
      >

        <v-tabs v-model="tab">
          <v-tab>
            General
          </v-tab>

          <v-tab>
            Applications ({{ applications.length }}) {{ hasOnlyEnglishCourses ? '🇬🇧' : '' }}
          </v-tab>
        </v-tabs>

      </v-tabs>
  
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card
            flat
            :disabled="$store.state.loadingApp !== 0"
          >
            <v-card class="d-flex flex-column my-4 rounded-xl">
              <v-card
                flat
                class="d-flex flex-row flex-wrap"
              >
                <span
                  class="px-6 py-2"
                  style="width: 400px"
                >
                  <v-card-title>
                    Client
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span
                      v-if="updatedClient.number_people === null"
                      class="py-2"
                    >Name: <span class="font-weight-bold">{{ updatedClient.first_name }} {{ updatedClient.last_name }}</span></span>
                    <span
                      v-if="updatedClient.number_people !== null"
                      class="py-2"
                    >Group: <span class="font-weight-bold">{{ updatedClient.last_name }}</span></span>
                    <span class="py-2">Birthdate: <span class="font-weight-bold">{{ updatedClient.birthdate }}</span> ({{ calcAge }} years)</span>
                    <span
                      v-if="updatedClient.number_people === null"
                      class="py-2"
                    >Gender: <span class="font-weight-bold">{{ updatedClient.gender }}</span>
                      <span
                        v-if="updatedClient.gender === 'Male'"
                        class="px-2"
                      ><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-male</v-icon></span>
                      <span
                        v-else-if="updatedClient.gender === 'Female'"
                        class="px-2"
                      ><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-female</v-icon></span>
                      <span
                        v-else
                        class="px-2"
                      ><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-genderless</v-icon></span>
                    </span>
                    <span class="py-2">Nationality: <span class="font-weight-bold">{{ getNationalityName }}</span></span>
                    <span
                      v-if="updatedClient.number_people === null"
                      class="py-2"
                    >Occupation: <span class="font-weight-bold">{{ updatedClient.occupation }}</span></span>
                    <span
                      v-if="updatedClient.number_people === null"
                      class="py-2"
                    >Food preference: <span class="font-weight-bold">{{ updatedClient.food_preference }}</span></span>
                    <span
                      v-if="updatedClient.number_people === null"
                      class="py-2"
                    >Pets preference: <span class="font-weight-bold">{{ updatedClient.pets_preference }}</span></span>
                  </v-card-text>
                </span>
                <span
                  class="px-6 py-2"
                  style="width: 400px"
                >
                  <v-card-title>
                    Contact info
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span class="py-2 d-flex align-center">
                      Email (PM):
                      <span class="font-weight-bold ml-1">{{ updatedClient.email }}</span>

                      <v-btn
                        v-if="updatedClient.email"
                        icon
                        x-small
                        class="ml-1"
                        @click="copyToClipboard(updatedClient.email)"
                      >
                        <v-icon small>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </span>
                    <span class="py-2 d-flex align-center">
                      Email Alternative:
                      <span class="font-weight-bold ml-1">{{ updatedClient.email_cc }}</span>

                      <v-btn
                        v-if="updatedClient.email_cc"
                        icon
                        x-small
                        class="ml-1"
                        @click="copyToClipboard(updatedClient.email_cc)"
                      >
                        <v-icon small>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </span>

                    <span class="py-2 d-flex align-center">
                      Phone:
                      <span class="font-weight-bold ml-1">{{ updatedClient.phone }}</span>

                      <v-btn
                        v-if="updatedClient.phone"
                        icon
                        x-small
                        class="ml-1"
                        @click="copyToClipboard(updatedClient.phone)"
                      >
                        <v-icon small>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </span>

                    <span class="py-2 d-flex align-center">
                      Alternative phone:
                      <span class="font-weight-bold ml-1">{{ updatedClient.phone_alt }}</span>

                      <v-btn
                        v-if="updatedClient.phone_alt"
                        icon
                        x-small
                        class="ml-1"
                        @click="copyToClipboard(updatedClient.phone_alt)"
                      >
                        <v-icon small>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </span>
                  </v-card-text>
                </span>
                <span
                  class="px-6 py-2"
                  style="width: 400px"
                >
                  <v-card-title>
                    Source/Agency
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span
                      v-if="updatedClient.agency_id !== null"
                      class="py-2"
                    >Agency: <span class="font-weight-bold">{{ updatedClient.agency }}</span></span>
                    <span
                      v-else
                      class="py-2"
                    >Source: <span class="font-weight-bold">{{ getSourceName }}</span></span>
                    <span class="py-2">Contact PPC: <span class="font-weight-bold">{{ getSalesContactName }}</span></span>
                  </v-card-text>
                </span>
                <span
                  class="px-6 py-2"
                  style="width: 400px"
                >
                  <v-card-title>
                    Emergency Contact
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span class="py-2">Name: <span class="font-weight-bold">{{ updatedClient.ice_full_name }}</span></span>
                    <span class="py-2">Email: <span class="font-weight-bold">{{ updatedClient.ice_email }}</span></span>
                    <span class="py-2">Phone: <span class="font-weight-bold">{{ updatedClient.ice_phone }}</span></span>
                    <span class="py-2">Alternative phone: <span class="font-weight-bold">{{ updatedClient.ice_phone_alt }}</span></span>
                  </v-card-text>
                </span>
                <span
                  class="px-6 py-2"
                  style="width: 400px"
                >
                  <v-card-title>
                    Pick Up Details from Client
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span class="py-2">
                      <span class="font-weight-bold">{{ updatedClient.pickup_type }} 
                        <span v-if="updatedClient.pickup_type !== 'To be confirmed' & updatedClient.pickup_type !== 'Not applicable'">
                          <span v-if="updatedClient.pickup_type === 'Address'"> at {{ updatedClient.pickup_address }}</span> <span v-if="updatedClient.pickup_type === 'Flight'">{{ updatedClient.pickup_nr }}</span> {{ formattedDate(updatedClient.pickup_date) }} <span v-if="updatedClient.pickup_type === 'Flight' || updatedClient.pickup_type === 'Bus'">{{ getPickUpTime }} from {{ updatedClient.pickup_from }} with {{ updatedClient.pickup_company }}</span>
                        </span>
                      </span>
                    </span>
                  </v-card-text>
                </span>
                <v-card
                  class="ma-4 px-6 py-2"
                  style="width: 800px"
                >
                  <v-card-title>
                    Comments
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span class="py-2"><span class="font-weight-bold">{{ updatedClient.comments }}</span></span>
                  </v-card-text>
                </v-card>
                <v-card
                  class="ma-4 px-6 py-2"
                  style="width: 800px"
                >
                  <v-card-title>
                    Expectations
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span class="py-2"><span class="font-weight-bold">{{ updatedClient.expectations }}</span></span>
                  </v-card-text>
                </v-card>
                <v-card
                  class="ma-4 px-6 py-2"
                  style="width: 800px"
                >
                  <v-card-title>
                    Experience
                  </v-card-title>
                  <v-card-text class="d-flex flex-column">
                    <span class="py-2"><span class="font-weight-bold">{{ updatedClient.experience }}</span></span>
                  </v-card-text>
                </v-card>
              </v-card>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="my-6 rounded-xl white--text"
                  color="ppc_darkgreen"
                  large
                  width="99%"
                  :disabled="$store.state.loadingApp > 0 || savingClient"
                  @click="openDialogEditClientBasic()"
                >
                  <v-icon
                    left
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                  Edit the Client Information
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>

            <!-- files upload section -->

            <v-card
              flat
              class="d-flex flex-row flex-wrap justify-center justify-md-start"
            >
              <!-- CV -->

              <v-card 
                class="d-flex flex-column align-start my-1 ma-sm-3 ma-md-5 pa-5 md12 rounded-xl" 
                min-width="400px"
                @drop.prevent="onDrop($event, 'cv')"
                @dragover.prevent="dragover = true"
                @dragenter.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
              >
                <v-card flat>
                  <h2 class="grey--text">
                    <v-icon
                      size="40"
                      class="mr-2"
                    >
                      mdi-text-box
                    </v-icon>Curriculum Vitae
                  </h2>
                </v-card>
                <v-card 
                  v-if="getUploadInfoType('cv').length > 0"
                  flat 
                  class="mx-auto my-5"
                >
                  <v-list>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(file, index) in getUploadInfoType('cv')"
                        :key="index"
                        class="d-flex flex-row flex-wrap"
                      >
                        <span
                          class="d-inline-block text-truncate"
                          style="max-width: 180px;"
                        >{{ file.name }}</span>
                        <div>
                          <v-btn
                            color="ppc_pink"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            @click="downloadFile(file.id)"
                          >
                            <v-icon>
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-btn
                            color="ppc_pink"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            @click="deleteFile(file.id)"
                          >
                            <v-icon>
                              $vuetify.icons.icon_mdi_delete
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div
                    v-if="getUploadInfoType('cv')[0].approved"
                    class="align-self-center"
                  >
                    <v-icon color="ppc_darkgreen">
                      $vuetify.icons.icon_mdi_check
                    </v-icon>
                    <strong>cv approved!</strong>
                  </div>
                </v-card>
                <v-card
                  v-else
                  flat
                  class="d-flex flex-column align-self-center"
                >
                  <v-card
                    flat
                    width="320px"
                  >
                    <v-file-input 
                      :rules="fileRules"
                      small-chips 
                      show-size 
                      label="Select or Drop docx or pdf" 
                      accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :disabled="selectFileCV"
                      @change="selectFile($event, 'cv')"
                    />
                  </v-card>
                  <v-icon
                    :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"
                    size="60"
                  >
                    mdi-cloud-upload
                  </v-icon>
                </v-card>
              </v-card>

              <!-- Passport -->

              <v-card 
                class="d-flex flex-column align-start my-1 ma-sm-3 ma-md-5 pa-5 rounded-xl" 
                min-width="400px"
                @drop.prevent="onDrop($event, 'passport')"
                @dragover.prevent="dragover = true"
                @dragenter.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
              >
                <v-card flat>
                  <h2 class="grey--text">
                    <v-icon
                      size="40"
                      class="mr-2"
                    >
                      mdi-passport
                    </v-icon>Passport Scan
                  </h2>
                </v-card>
                <v-card
                  v-if="getUploadInfoType('passport').length > 0"
                  flat
                  class="mx-auto my-5"
                >
                  <v-list>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(file, index) in getUploadInfoType('passport')"
                        :key="index"
                        class="d-flex flex-row flex-wrap"
                      >
                        <span
                          class="d-inline-block text-truncate"
                          style="max-width: 180px;"
                        >{{ file.name }}</span>
                        <div>
                          <v-btn
                            color="ppc_pink"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            @click="downloadFile(file.id)"
                          >
                            <v-icon>
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-btn
                            color="ppc_pink"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            @click="deleteFile(file.id)"
                          >
                            <v-icon>
                              $vuetify.icons.icon_mdi_delete
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div
                    v-if="getUploadInfoType('passport')[0].approved"
                    class="align-self-center"
                  >
                    <v-icon color="ppc_darkgreen">
                      $vuetify.icons.icon_mdi_check
                    </v-icon>
                    <strong>passport approved!</strong>
                  </div>
                </v-card>
                <div
                  v-else
                  class="d-flex flex-column align-self-center"
                >
                  <v-card
                    flat
                    width="320px"
                  >
                    <v-file-input 
                      :rules="fileRules"
                      small-chips 
                      show-size 
                      label="Select or Drop jpeg, png or pdf file" 
                      accept=".pdf,image/*"
                      :disabled="selectFilePassport"
                      @change="selectFile($event, 'passport')"
                    />
                  </v-card>
                  <v-icon
                    :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"
                    size="60"
                  >
                    mdi-cloud-upload
                  </v-icon>
                </div>
              </v-card>

              <!-- Other uploads -->

              <v-card 
                class="d-flex flex-column align-start my-1 ma-sm-3 ma-md-5 pa-5 rounded-xl" 
                min-width="400px"
                @drop.prevent="onDrop($event, 'other')"
                @dragover.prevent="dragover = true"
                @dragenter.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
              >
                <v-card flat>
                  <h2 class="grey--text">
                    <v-icon
                      size="40"
                      class="mr-2"
                    >
                      mdi-upload
                    </v-icon>Other Uploads
                  </h2>
                </v-card>
                <v-card
                  flat
                  class="mx-auto my-5"
                >
                  <v-list>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(file, index) in getUploadInfoType('other')"
                        :key="index"
                        class="d-flex flex-row flex-wrap"
                      >
                        <span
                          class="d-inline-block text-truncate"
                          style="width: 180px;"
                        >{{ file.name }}</span>
                        <div>
                          <v-btn
                            color="ppc_pink"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            @click="downloadFile(file.id)"
                          >
                            <v-icon>
                              mdi-download
                            </v-icon>
                          </v-btn>
                          <v-btn
                            color="ppc_pink"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            @click="deleteFile(file.id)"
                          >
                            <v-icon>
                              $vuetify.icons.icon_mdi_delete
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
                <div class="d-flex flex-column align-self-center">
                  <v-card
                    flat
                    width="320px"
                  >
                    <v-file-input
                      v-model="fileOther"
                      :rules="fileRules"
                      small-chips
                      show-size
                      label="Select or Drop a file"
                      :disabled="selectFileOther"
                      @change="selectFile($event, 'other')"
                    />
                  </v-card>
                  <v-icon
                    :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"
                    size="60"
                  >
                    mdi-cloud-upload
                  </v-icon>
                </div>
              </v-card>

                

              <!-- Spanish Test -->

              <v-card
                class="d-flex flex-column my-1 ma-sm-3 ma-md-5 pa-5 rounded-xl"
                width="320px"
              >
                <v-card flat>
                  <h2 class="grey--text">
                    <v-icon
                      size="40"
                      class="mr-2"
                    >
                      mdi-file-document-edit
                    </v-icon>Spanish Test
                  </h2>
                </v-card>
                <v-spacer />
                <v-card
                  flat
                  class="align-self-center"
                >
                  <v-menu 
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        :value="formattedDate(updatedClient.spanishTestDone)" 
                        label="Select test date" 
                        v-bind="attrs" 
                        prepend-icon="$vuetify.icons.icon_mdi_calendar ppc_darkgreen--text"
                        clearable
                        readonly
                        v-on="on"
                        @click:clear="updatedClient.spanishTestDone = null"
                        @change="saveClient()"
                      />
                    </template>
                    <v-date-picker 
                      v-model="updatedClient.spanishTestDone"
                      color="ppc_darkgreen"
                      scrollable
                      @change="saveClient()"
                    />
                  </v-menu>
                  <v-select
                    v-model="updatedClient.initial_spanish_level"
                    style="width: 250px"
                    :items="$store.state.language_levels"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Level"
                    single-line
                    prepend-icon="mdi-star ppc_darkgreen--text"
                    validate-on-blur
                    clearable
                    @change="saveClient()"
                  />
                </v-card>
              </v-card>
            </v-card>

            <v-card
              flat
              class="d-flex flex-row flex-wrap"
            >
              <v-card class="d-flex flex-column my-1 ma-sm-3 ma-md-5 pa-5 rounded-xl">
                <v-card-title>Sales Info</v-card-title>
                <v-card
                  flat
                  class="d-flex flex-column"
                >
                  <span
                    class="pa-6 pb-2"
                    style="width: 250px"
                  >
                    <h3 class="grey--text">
                      Sales Contact
                    </h3>
                    <v-select
                      v-model="updatedClient.salesContact"
                      :items="selectContactsStaff"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ auto: true }"
                      label="Select sales contact"
                      single-line
                      prepend-icon="fa-comments-dollar ppc_darkgreen--text"
                      validate-on-blur
                      :disabled="updatedClient.agency_id !== null"
                      @change="saveClient()"
                    />
                  </span>

                  <span
                    class="pa-6"
                    style="width: 250px"
                  >
                    <h3 class="grey--text">
                      First Contact Lead
                    </h3>
                    <v-menu 
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          :value="formattedDate(updatedClient.firstContactLead)"
                          label="On" 
                          v-bind="attrs" 
                          prepend-icon="$vuetify.icons.icon_mdi_calendar"
                          clearable
                          readonly
                          v-on="on"
                          @change="saveClient()"
                          @click:clear="updatedClient.firstContactLead=null"
                        />
                      </template>
                      <v-date-picker 
                        v-model="updatedClient.firstContactLead"
                        color="ppc_darkgreen"
                        scrollable
                        @change="saveClient()"
                      />
                    </v-menu>
                  </span>

                  <span
                    class="pa-6"
                    style="width: 250px"
                  >
                    <h3 class="grey--text">
                      First Contact PPC
                    </h3>
                    <v-menu 
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          :value="formattedDate(updatedClient.firstContactPPC)"
                          label="On" 
                          v-bind="attrs" 
                          prepend-icon="$vuetify.icons.icon_mdi_calendar"
                          clearable
                          readonly
                          v-on="on"
                          @change="saveClient()"
                          @click:clear="updatedClient.firstContactPPC=null"
                        />
                      </template>
                      <v-date-picker 
                        v-model="updatedClient.firstContactPPC"
                        color="ppc_darkgreen"
                        scrollable
                        @change="saveClient()"
                      />
                    </v-menu>
                  </span>

                  <span
                    class="pa-6"
                    style="width: 250px"
                  >
                    <h3 class="grey--text">
                      Next Contact On
                    </h3>
                    <v-menu 
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          :value="formattedDate(updatedClient.nextContact)"
                          label="On" 
                          v-bind="attrs" 
                          prepend-icon="$vuetify.icons.icon_mdi_calendar"
                          clearable
                          readonly
                          v-on="on"
                          @change="saveClient()"
                          @click:clear="updatedClient.nextContact=null"
                        />
                      </template>
                      <v-date-picker 
                        v-model="updatedClient.nextContact"
                        color="ppc_darkgreen"
                        scrollable
                        @change="saveClient()"
                      />
                    </v-menu>
                  </span>
                </v-card>
              </v-card>

              <v-card class="d-flex flex-column my-1 ma-sm-3 ma-md-5 pa-5 rounded-xl">
                <v-card
                  flat
                  class="d-flex flex-row flex-wrap"
                >
                  <span
                    class="pa-6"
                    style="width: 300px"
                  >
                    <div class="d-flex flex-column">
                      <h2 class="grey--text"> 
                        <v-btn 
                          fab
                          color="blue" 
                          elevation="2"
                          x-small 
                          :disabled="checkBoolean(updatedClient.ignore_welcome_email)" 
                          @click="sentWelcomeEmail(addPaymentInfo)"
                        >
                          <v-icon
                            size="20"
                            color="white"
                          >mdi-email</v-icon>
                        </v-btn>
                        Welcome Email
                      </h2>
                      <span>
                        <v-radio-group
                          v-model="school_welcome_email"
                          row
                          class="mt-2"
                        >
                          <v-radio
                            label="Spanish School"
                            value="spanish"
                            class="my-0 py-0"
                          />
                          <v-radio
                            label="English School"
                            value="english"
                            class="my-0 py-0"
                          />
                        </v-radio-group>
                        <v-checkbox 
                          v-model="updatedClient.ignore_welcome_email"
                          label="Ignore"
                          class="mt-0 pt-0 mr-2"
                          color="blue"
                          @change="saveClient()"
                        />
                        <v-checkbox 
                          v-model="addPaymentInfo"
                          label="Add Payment Info"
                          class="mt-0 pt-0 mr-2"
                          color="blue"
                          :disabled="checkBoolean(updatedClient.ignore_welcome_email) || school_welcome_email === 'english'"
                        />
                        <v-checkbox 
                          v-model="updatedClient.includeHandbook"
                          label="Include Handbook"
                          class="mt-0 pt-0 mr-2"
                          color="blue"
                          :disabled="checkBoolean(updatedClient.ignore_welcome_email) || school_welcome_email === 'english'"
                        />
                      </span>
                      <v-menu 
                        transition="scale-transition"
                        offset-y
                        :disabled="checkBoolean(updatedClient.ignore_welcome_email)"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field 
                            :value="formattedDate(updatedClient.welcome_email)"
                            label="Sent date" 
                            v-bind="attrs" 
                            prepend-icon="$vuetify.icons.icon_mdi_calendar"
                            clearable
                            :disabled="checkBoolean(updatedClient.ignore_welcome_email)"
                            v-on="on"
                            @click:clear="updatedClient.welcome_email=null"
                            @change="saveClient()"
                          />
                        </template>
                        <v-date-picker 
                          v-model="updatedClient.welcome_email"
                          color="ppc_darkgreen"
                          scrollable
                          @change="saveClient()"
                        />
                      </v-menu>
                    </div>
                  </span>
                  <div class="d-flex flex-column">
                    <span
                      class="pa-6"
                      style="width: 250px"
                    >
                      <h2 class="grey--text mt-1">
                        Handbook
                      </h2>
                      <v-card
                        flat
                        class="align-self-center"
                      >
                        <v-menu 
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                              :value="formattedDate(updatedClient.handbookSent)" 
                              label="Sent date" 
                              v-bind="attrs" 
                              prepend-icon="$vuetify.icons.icon_mdi_calendar"
                              readonly
                              clearable
                              v-on="on"
                              @change="saveClient()"
                              @click:clear="updatedClient.handbookSent=null"
                            />
                          </template>
                          <v-date-picker 
                            v-model="updatedClient.handbookSent"
                            color="ppc_darkgreen"
                            scrollable
                            @change="saveClient()"
                          />
                        </v-menu>
                      </v-card>
                      <span
                        v-if="updatedClient.sendHandbook === 0"
                        class="mx-2"
                      >Responsibility Agency</span>
                    </span>
                    <span
                      class="pa-6"
                      style="width: 250px"
                    >
                      <h2 class="grey--text mt-1"> 
                        First Schedule
                      </h2>
                      <v-menu 
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field 
                            :value="formattedDate(updatedClient.first_schedule_sent)"
                            label="Sent date"
                            v-bind="attrs" 
                            prepend-icon="$vuetify.icons.icon_mdi_calendar"
                            clearable
                            v-on="on"
                            @change="saveClient()"
                            @click:clear="updatedClient.first_schedule_sent=null"
                          />
                        </template>
                        <v-date-picker 
                          v-model="updatedClient.first_schedule_sent"
                          color="ppc_darkgreen"
                          scrollable
                          @change="saveClient()"
                        />
                      </v-menu>
                    </span>
                  </div>
                  <span
                    class="pa-6"
                    style="width: 300px"
                  >
                    <div class="d-flex flex-row flex-wrap">
                      <h2 class="grey--text"> 
                        <v-btn 
                          fab
                          color="blue" 
                          elevation="2"
                          x-small 
                          :disabled="checkBoolean(updatedClient.ignore_thank_you_email)" 
                          @click="sentThankYouEmail()"
                        >
                          <v-icon
                            size="20"
                            color="white"
                          >mdi-email</v-icon>
                        </v-btn>
                        Thank You Email
                      </h2>
                      <v-checkbox 
                        v-model="updatedClient.ignore_thank_you_email"
                        label="ignore"
                        class="mt-6 pt-0 mr-2"
                        color="blue"
                        @change="saveClient()"
                      />
                    </div>
                    <v-menu 
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          :value="formattedDate(updatedClient.thank_you_email)" 
                          label="Sent date" 
                          v-bind="attrs" 
                          prepend-icon="$vuetify.icons.icon_mdi_calendar"
                          clearable
                          :disabled="checkBoolean(updatedClient.ignore_thank_you_email)"
                          v-on="on"
                          @change="saveClient()"
                          @click:clear="updatedClient.thank_you_email=null"
                        />
                      </template>
                      <v-date-picker 
                        v-model="updatedClient.thank_you_email"
                        color="ppc_darkgreen"
                        scrollable
                        :disabled="checkBoolean(updatedClient.ignore_thank_you_email)"
                        @change="saveClient()"
                      />
                    </v-menu>
                  </span>
                </v-card>
              </v-card>
                
              <v-card
                flat
                elevation="3"
                class="my-1 ma-sm-3 ma-md-5 pa-5 rounded-xl my-4"
              >
                <v-card-title>Security Deposits USD</v-card-title>
                <v-card-actions>
                  <v-btn
                    x-small
                    @click="goFinancial('add')"
                  >
                    receive Security Deposit
                  </v-btn>
                  <v-btn
                    x-small
                    @click="goFinancial('remove')"
                  >
                    return Security Deposit
                  </v-btn>
                </v-card-actions>
                <v-data-table
                  v-if="securityDeposits.length > 0"
                  :headers="headersSecurityDeposits"
                  hide-default-header
                  :items="securityDeposits"
                  sort-by="dateTime"
                  dense
                  :items-per-page="-1"
                  disable-pagination
                  hide-default-footer
                  style="width: 200px;"
                >
                  <template v-slot:[`item.dateTime`]="{ item }">
                    <span v-html="formattedDate(item.dateTime, 'date')" />
                  </template>
                  <template v-slot:[`item.amountDollars`]="{ item }">
                    $<span
                      v-if="item.amountDollars"
                      v-html="decUtil.format(decUtil.toDec(item.amountDollars))"
                    />
                  </template>
                </v-data-table>
                <v-card
                  flat
                  class="d-flex flex-row flex-wrap"
                >
                  <div>
                    <v-card-text v-if="!updatedClient.ignore_security_deposit">
                      Total: {{ updatedClient.totalSecurityDeposit }} USD
                    </v-card-text>
                  </div>
                  <v-card-actions> 
                    <v-checkbox
                      v-model="updatedClient.ignore_security_deposit"
                      label="Ignore"
                      class="mt-2 py-0"
                      @change="saveClient()"
                    />
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-card>
            
            <v-card-actions>
              <v-spacer />
              <v-btn
                large 
                text 
                class="mr-4" 
                :disabled="updatedClient.clientPayments === true || checkAllApplicationsBeforeDelete() !== 'ok' || $store.state.loadingApp > 0" 
                @click="confirmDeleteClientDialog = true"
              >
                <span v-if="updatedClient.clientPayments === false && checkAllApplicationsBeforeDelete() === 'ok'"><v-icon
                  color="ppc_darkgreen darken-1"
                  class="mx-1"
                >$vuetify.icons.icon_mdi_delete</v-icon>Remove Client</span>
                <span v-if="updatedClient.clientPayments === true"><v-icon
                  color="ppc_darkgreen darken-1"
                  class="mx-1"
                >$vuetify.icons.icon_mdi_delete_off</v-icon>Client payments exists</span>
                <span v-if="checkAllApplicationsBeforeDelete() !== 'ok'"><v-icon
                  color="ppc_darkgreen darken-1"
                  class="mx-1"
                >$vuetify.icons.icon_mdi_delete_off</v-icon>Client has applications</span>
              </v-btn>
              <v-tooltip
                v-if="updatedClient.statusClientId !== 8 && updatedClient.statusClientId !== 9"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn 
                    class="mr-4"
                    large 
                    text 
                    :disabled="checkAllApplicationsBeforeDelete() !== 'ok' || $store.state.loadingApp > 0" 
                    v-on="on" 
                    @click="cancelClient()"
                  >
                    <v-icon
                      color="ppc_darkgreen darken-1"
                      class="mx-1"
                    >
                      $vuetify.icons.icon_mdi_account_cancel
                    </v-icon>
                    Cancel Client
                  </v-btn>
                </template>
                <span>This will remove all applications!</span>
              </v-tooltip>
              <v-tooltip
                v-if="updatedClient.statusClientId === 8 || updatedClient.statusClientId === 9"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn 
                    class="mr-4"
                    large 
                    text 
                    :disabled="$store.state.loadingApp > 0" 
                    v-on="on" 
                    @click="resetStatusClient()"
                  >
                    <v-icon
                      color="ppc_darkgreen darken-1"
                      class="mx-1"
                    >
                      $vuetify.icons.icon_mdi_account_cancel
                    </v-icon>
                    Reset Status Client
                  </v-btn>
                </template>
                <span>This will remove all the applications of this client!</span>
              </v-tooltip>
              <v-btn
                v-if="updatedClient.statusClientId !== 8 && updatedClient.statusClientId !== 9"
                large
                text
                class="mr-4"
                :disabled="$store.state.loadingApp > 0"
                @click="copyClient"
              >
                <v-icon
                  color="ppc_darkgreen darken-1"
                  class="mx-1"
                >
                  $vuetify.icons.icon_mdi_account_box_multiple_outline
                </v-icon>
                Copy Client
              </v-btn>
              <v-btn
                v-if="updatedClient.statusClientId === 6"
                large
                text
                class="mr-4"
                @click="contactNoResponse"
              >
                <v-icon
                  color="ppc_darkgreen darken-1"
                  class="mx-1"
                >
                  mdi-phone-cancel
                </v-icon>
                Contact No Conversion
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!-- Tab Services -->
        <v-tab-item>
          <v-card
            class="mb-4"
            height="auto"
            flat
          >
            <v-card-title class="card-title">
              <v-spacer />
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="grey"
                    v-bind="attrs"
                    dark
                    fab
                    class="mx-2 my-0"
                    :disabled="$store.state.loadingApp > 0 || updatedClient.statusClientId === 8 || updatedClient.statusClientId === 9"
                    v-on="on"
                    @click="dialogAddType = true"
                  >
                    <v-icon>
                      $vuetify.icons.icon_mdi_plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>Add a Service</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text>
              <!-- Applications -->
              <v-card  
                v-for="(application, indexApplications) in applications"
                :key="application.id"
                flat
                class="d-flex flex-row flex-wrap pa-5 mt-3 rounded-xl"
                :color="passToPlanningColor(application.pass_to_planning)"
              >
                <div
                  class="d-flex flex-column"
                  style="width: 100%;"
                >
                  <div
                    class="d-flex flex-row flex-wrap justify-space-between mb-8"
                    style="width: 100%;"
                  >
                    <v-card-title>
                      <h2 class="white--text">
                        #{{ applications.length - indexApplications }} {{ application.appTitle }}
                      </h2>
                    </v-card-title>
                    <div class="d-flex flex-row flex-wrap">
                      <v-switch
                        v-if="!appPlanned(application.id)"
                        v-model="application.pass_to_planning"
                        color="white"
                        class="mx-4"
                        :disabled="$store.state.loadingApp > 0"
                        @change="passToPlanning($event, application)"
                      >
                        <template v-slot:label>
                          <span
                            class="#688f69"
                            style="color: #FFF;"
                          >Pass to Planning</span>
                        </template>
                      </v-switch>
                      <v-switch
                        v-model="application.syncPM"
                        color="white"
                        class="mx-4"
                        :disabled="application.payerClient === null && application.payerAgency === null || $store.state.loadingApp > 0"
                        @change="changeSynchronise($event, application)"
                      >
                        <template v-slot:label>
                          <span
                            class="#688f69"
                            style="color: #FFF;"
                          >Synchronise PM</span>
                        </template>
                      </v-switch>
                      <div v-if="application.statusAppId !== 99">
                        <v-chip
                          :color="getStatusApp(application.statusAppId).color"
                          class="my-4"
                          text-color="white"
                          v-html="getStatusApp(application.statusAppId).name"
                        />                      
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex flex-row flex-wrap justify-space-around"
                    style="width: 100%;"
                  >
                    <span
                      v-if="application.frozen || application.frozen === 1"
                      class="white--text my-0 mx-2 text-h5"
                    >Application Frozen</span>
                  </div>
                  
                  <div
                    class="d-flex flex-row flex-wrap justify-space-around"
                    style="width: 100%;"
                  >
                    <v-btn
                      class="my-8 py-8 rounded-xl white--text"
                      large
                      color="#7c9b7d"
                      width="99%"
                      :disabled="$store.state.loadingApp > 0 && !initializing"
                      @click="displayApplication(application)"
                    >
                      <v-icon
                        left
                      >
                        $vuetify.icons.icon_mdi_pencil
                      </v-icon>
                      Edit the Application
                    </v-btn>
                  </div>
                  <div
                    class="d-flex flex-row"
                    style="width: 100%;"
                  >
                    <div style="min-width: 300px">
                      <v-card
                        class="black--text ma-2 pa-6 rounded-xl"
                        color="ppc_grey"
                      >
                        <div
                          v-if="application.totalPrice !== null"
                          class="d-flex flex-column"
                        >
                          <h2 class="black--text my-2">
                            Total:
                          </h2>
                          <h3 class="black--text d-flex flex-row justify-space-between">
                            <span>Price:</span> 
                            <span>${{ decUtil.format(application.totalPrice, 2) }}</span> 
                            <span>({{ decUtil.format(decUtil.toPEN(application.totalPrice, "$", application.exchangeRate),0) }} PEN)</span>
                          </h3>
                        </div>
                        <div v-if="application.amountPaidApplication && application.amountPaidApplication > 0">
                          <h3 class="black--text d-flex flex-row justify-space-between">
                            <span>Paid:</span>
                            <span>${{ decUtil.format(application.amountPaidApplication, 2) }}</span>
                            <span>({{ decUtil.format(decUtil.toPEN(application.amountPaidApplication, "$", application.exchangeRate),0) }} PEN)</span>
                          </h3>
                        </div>
                        <div v-else>
                          <h3 class="black--text d-flex flex-row justify-space-between">
                            <span>Paid:</span>
                            <span>-</span>
                            <span>-</span>
                          </h3>
                        </div>
                        <hr color="black">
                        <div v-if="!decUtil.equals(application.totalPrice, application.amountPaidApplication, '0.05')">
                          <h3 
                            v-if="formattedDate(application.start_first_service, 'date') > formattedDate($store.state.today, 'date')" 
                            class="d-flex flex-row justify-space-between"
                          >
                            <span>Open:</span>
                            <span class="ppc_darkgreen--text">${{ decUtil.format(decUtil.toDec(application.totalPrice).minus(application.amountPaidApplication), 2) }}</span>
                            <span class="ppc_darkgreen--text">(S/.{{ decUtil.format(decUtil.toPEN(decUtil.toDec(application.totalPrice).minus(application.amountPaidApplication), "$", application.exchangeRate),0) }})</span>
                          </h3>
                          <h3
                            v-else
                            class="d-flex flex-row justify-space-between"
                          >
                            <span>Open:</span>
                            <span><FONT c-o-l-o-r="red">${{ decUtil.format(decUtil.toDec(application.totalPrice).minus(application.amountPaidApplication), 2) }}</FONT></span>
                            <span><FONT c-o-l-o-r="red">(S/.{{ decUtil.format(decUtil.toPEN(decUtil.toDec(application.totalPrice).minus(application.amountPaidApplication), "$", application.exchangeRate),0) }})</FONT></span>
                          </h3>
                        </div>
                        <div v-else>
                          <FONT c-o-l-o-r="darkgreen">
                            <strong>ALL PAID</strong>
                          </FONT>
                        </div>
                      </v-card>
                      <v-card-text class="white--text">
                        <div>Applied: {{ formattedDate(application.applied) }}</div>
                        <div>{{ application.amountOfClients }} client(s) in application</div>
                        <div v-if="application.payerAgency === null">
                          Payer Client: {{ application.payerClientName }}
                        </div>
                        <div v-if="application.payerAgency !== null">
                          Payer Agency: {{ application.payerAgencyName }}
                        </div>
                      </v-card-text>
                      <hr
                        color="white"
                        class="my-4"
                      >
                      <div v-if="application.comments">
                        <h3 class="white--text">
                          Invoice Comments
                        </h3>
                        <v-card-text
                          class="white--text"
                          style="max-width: 300px;"
                        >
                          <div>{{ application.comments }}</div>
                        </v-card-text>
                        <hr
                          color="white"
                          class="my-4"
                        >
                      </div>
                      <v-card-text class="white--text">
                        <div class="mt-2">
                          app nr: {{ application.id }}
                        </div>
                        <div
                          v-if="application && application.lastChangedByName"
                          class="mt-2"
                        >
                          last changed by {{ application.lastChangedByName }}
                        </div>
                      </v-card-text>
                    </div>
                    <div class="d-flex flex-row flex-wrap align-start">
                      <v-card  
                        v-for="item in filterServices(application.id)"
                        :key="item.id"
                        flat 
                        class="d-flex flex-column ma-2 pa-4 rounded-xl justify-space-between"
                        color="ppc_grey"
                        min-width="400px"
                        max-width="800px"
                        min-height="400px"
                      >
                        <div
                          class="d-flex flex-column"
                          style="min-height: 250px;"
                        >
                          <v-card-title>
                            <h2>{{ item.name }}</h2>
                          </v-card-title>
                          <v-card-text>
                            <div>
                              From {{ formattedDate(item.start) }} 
                            </div>
                            <div>
                              Until {{ formattedDate(item.end) }}
                            </div>
                            <div>
                              Duration: {{ item.duration || 'Not set' }} {{ item.duration_text }}
                            </div>
                            <div>
                              Price:
                              <span v-if="item.servicePrice">
                                &nbsp;{{ item.currency }}
                                <span v-if="item.currency === 'S/.'">
                                  {{ decUtil.format(item.servicePrice,0) || 'Not set' }} 
                                </span>
                                <span v-else>
                                  {{ decUtil.format(item.servicePrice) || 'Not set' }} 
                                </span>
                              </span>
                              <span v-if="item.currency === 'S/.'">
                                (${{ decUtil.format(decUtil.toUSD(item.servicePrice, item.currency, $store.state.exchangeRate)) }})
                              </span>
                            </div>
                            <div v-if="updatedRadioGroups_filtered(item.id).length > 0">
                              <div
                                v-for="radio_group in updatedRadioGroups_filtered(item.id)"
                                :key="radio_group.radio_group_id + '-' + radio_group.services_id"
                              >
                                - {{ radio_group.radio_group_value }}
                              </div>
                            </div>
                            <div v-if="updatedOptions_filtered(item.id).length > 0">
                              <div
                                v-for="option in updatedOptions_filtered(item.id)"
                                :key="option.option_id + '-' + option.services_id"
                              >
                                <div v-if="option.selected === 1">
                                  - {{ option.option_question }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="d-flex flex-row flex-wrap justify-space-around"
                              style="width: 100%;"
                            >
                              <v-btn
                                class="my-8 py-4 rounded-xl white--text"
                                color="grey"
                                width="99%"
                                :disabled="$store.state.loadingApp > 0"
                                @click="editService(item)"
                              >
                                <v-icon
                                  left
                                >
                                  $vuetify.icons.icon_mdi_pencil
                                </v-icon>
                                Edit the Service
                              </v-btn>
                            </div>
                            <div
                              style="width: 100%;"
                              class="d-flex flex-row"
                            >
                              <v-spacer />
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="blue"
                                    v-bind="attrs"
                                    dark
                                    x-small
                                    fab
                                    class="mx-0 my-0"
                                    v-on="on"
                                    @click="serviceIdToResource = item.id, dialog_add_resource = true"
                                  >
                                    <v-icon 
                                      v-on="on"
                                    >
                                      $vuetify.icons.icon_mdi_plus
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Add a Resource</span>
                              </v-tooltip>
                            </div>
                          </v-card-text>
                        </div>
                        <div class="d-flex flex-row flex-wrap justify-space-around align-stretch">
                          <v-card  
                            v-for="resource in filterResources(item.id)"
                            :key="resource.id"
                            flat
                            class="d-flex flex-row flex-wrap ma-1 pa-0 rounded-xl"
                            color="blue"
                            min-width="350px"
                            min-height="50px"
                            width="20%"
                          >
                            <div
                              class="d-flex flex-column justify-space-between"
                              style="width: 100%;"
                            >
                              <v-card-text>
                                <div v-if="resource.type_id === 1 || resource.type_id === 2">
                                  <h4>{{ getResourceTypeName(resource.type_id) }} #{{ resource.number_type }}</h4>
                                  <div>
                                    Category: <span v-if="resource.category_id">{{ getProjectCategory(resource.category_id) }}</span><span v-else>to be selected</span>
                                  </div>
                                  <div>
                                    Project: <span v-if="resource.project_id">{{ getProjectName(resource.project_id) }}</span><span v-else>to be selected</span>
                                  </div>
                                </div>
                                <div v-if="resource.type_id === 3 || resource.type_id === 8">
                                  <h4>{{ resource.class_language }} #{{ resource.number_type }}</h4>
                                  <div>
                                    Language: {{ resource.class_language }}
                                  </div>
                                  <div>
                                    Type: {{ resource.class_group }} - {{ resource.class_type }}
                                  </div>
                                  <div>
                                    Duration: {{ resource.hours }} hours
                                  </div>
                                  <div>
                                    {{ resource.hours_per_class }} hours per class
                                  </div>
                                </div>
                                <div v-if="resource.type_id === 4">
                                  <h4>{{ getResourceTypeName(resource.type_id) }} #{{ resource.number_type }}</h4>
                                  <div>
                                    Type:
                                    <span v-if="resource.family == 0">Apartment</span>
                                    <span v-else>Family</span>
                                  </div>
                                  <div>
                                    Class: <span v-if="resource.accommodation_class">{{ resource.accommodation_class }}</span><span v-else>to be selected</span>
                                  </div>
                                </div>
                                <div v-if="resource.type_id === 5">
                                  <h4>{{ getResourceTypeName(resource.type_id) }} #{{ resource.number_type }}</h4>
                                  <div>
                                    Tour: <span v-if="resource.tour_id">{{ getTour(resource.tour_id).name }}</span><span v-else>to be selected</span>
                                  </div>
                                </div>
                                <div>
                                  From {{ formattedDate(resource.start) }}
                                </div>
                                <div>
                                  Until {{ formattedDate(resource.end) }}
                                </div>
                                <div v-if="resource.type_id === 4">
                                  <div>
                                    Nights: {{ resource.duration }}
                                  </div>
                                </div>
                                <div v-if="resource.type_id === 1 || resource.type_id === 2">
                                  <div>
                                    Weeks: {{ getBusinessWeeks(resource) }}
                                  </div>
                                </div>
                                <div>
                                  <span v-if="(resource.type_id === 1 || resource.type_id === 2) && resource.organisationName">Time: {{ resource.projectMorningAfternoon }}</span>
                                </div>
                                <div>
                                  <span v-if="resource.comments">Comments: {{ resource.comments }}</span><span v-else>No comments</span>
                                </div>

                                <v-btn
                                  class="my-4 py-4 rounded-xl white--text"
                                  small
                                  color="blue lighten-2"
                                  width="99%"
                                  :disabled="$store.state.loadingApp > 0"
                                  @click="editResource(resource)"
                                >
                                  <v-icon
                                    left
                                  >
                                    $vuetify.icons.icon_mdi_pencil
                                  </v-icon>
                                  Edit the Resource
                                </v-btn>
                                <v-card
                                  flat
                                  class="d-flex justify-space-around mt-4"
                                  color="blue"
                                  style="width: 100%"
                                >
                                  <v-btn 
                                    v-if="(resource.type_id === 3 || resource.type_id === 8) && (resource.start && resource.end) && ((application.pass_to_planning || application.pass_to_planning === 1) || appPlanned(application.id))"
                                    small
                                    class="mb-2 rounded-xl"
                                    @click="goTeaching(resource.id)"
                                  >
                                    <span v-if="resource.minutes_planned">{{ Math.round(((resource.minutes_planned / 60) * 2) / 2) }} hours planned</span>
                                    <span v-else>Passed to Planning</span>
                                  </v-btn>
                                  <v-btn 
                                    v-if="(resource.type_id === 1 || resource.type_id === 2) && (resource.start && resource.end) && ((application.pass_to_planning || application.pass_to_planning === 1) || appPlanned(application.id))"
                                    small
                                    class="ma-2 rounded-xl"
                                    @click="goProject(resource.id)"
                                  >
                                    <span v-if="resource.organisationName">{{ resource.organisationName }}</span>
                                    <span v-else>Passed to Planning</span>
                                  </v-btn>
                                  <v-btn 
                                    v-if="resource.type_id === 4 && (resource.start && resource.end) && ((application.pass_to_planning || application.pass_to_planning === 1) || appPlanned(application.id))"
                                    small
                                    class="mb-2 rounded-xl"
                                    @click="goAccommodation(resource.id)"
                                  >
                                    <span v-if="resource.room_id">{{ resource.resourceName }}</span>
                                    <span v-else>Passed to Planning</span>
                                  </v-btn>
                                  <v-btn 
                                    v-if="resource.type_id === 5 && ((application.pass_to_planning || application.pass_to_planning === 1) || appPlanned(application.id))"
                                    small
                                    class="ma-2 rounded-xl"
                                    @click="goTour(resource.id)"
                                  >
                                    <span v-if="resource.tour_placement_id">{{ resource.organisationName }}</span>
                                    <span v-else>Passed to Planning</span>
                                  </v-btn>
                                </v-card>
                              </v-card-text>
                              <v-card-actions>
                                <div
                                  v-if="resource.statusResourceId"
                                  class="align-self-end"
                                >
                                  <v-chip
                                    small
                                    :color="getStatusResource(resource.statusResourceId).color"
                                    class="ma-4"
                                    text-color="white"
                                    v-html="getStatusResource(resource.statusResourceId).name"
                                  />
                                </div>
                                <v-spacer />
                                <v-tooltip
                                  v-if="item.service_number > 0"
                                  left
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      x-small
                                      class="ma-2"
                                      fab
                                      color="blue lighten-2"
                                      :disabled="$store.state.loadingApp > 0 || checkResourceBeforeDelete(resource.id) !== 'ok' || changingResource !== null"
                                      @click.native.stop="resourceIdToDelete = resource.id, confirmDeleteResourceDialog = true"
                                    >
                                      <v-icon
                                        v-bind="attrs"
                                        v-on="on" 
                                      >
                                        $vuetify.icons.icon_mdi_delete
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Remove the Resource</span>
                                </v-tooltip>
                              </v-card-actions>
                            </div>
                          </v-card>
                        </div>
                        <v-card-actions class="d-flex flex-row flex-wrap">
                          <v-card
                            v-if="item.statusServiceId"
                            color="ppc_grey"
                            flat
                          >
                            <v-chip
                              small
                              :color="getStatusService(item.statusServiceId).color"
                              class="white--text mt-2"
                            >
                              {{ getStatusService(item.statusServiceId).name }}
                            </v-chip>
                          </v-card>
                          <v-spacer />
                          <v-tooltip
                            v-if="item.service_number > 0"
                            left
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn 
                                x-small
                                class="ma-2"
                                fab
                                color="grey"
                                :disabled="application.frozen || $store.state.loadingApp > 0 || checkApplicationIfRemovable(item.application_id) !== 'ok'"
                                @click="prepSelectServiceMove(item.id)"
                              >
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on" 
                                >
                                  mdi-file-replace
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Move the Service to another Application</span>
                          </v-tooltip>
                          <v-tooltip
                            v-if="item.service_number > 0"
                            left
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                class="ma-2"
                                fab
                                color="grey"
                                :disabled="application.frozen || $store.state.loadingApp > 0 || checkServiceBeforeDeleteOrUnapply(item.id) !== 'ok'"
                                @click="serviceIdToDelete = item.id, confirmDeleteServiceDialog = true"
                              >
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on" 
                                >
                                  $vuetify.icons.icon_mdi_delete
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Remove the Service</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </div>
                  </div>
                </div>
                <div
                  style="width: 100%;"
                  class="d-flex flex-row"
                >
                  <v-spacer />
                  <v-tooltip
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        small 
                        class="ma-2"
                        color="#7c9b7d"
                        :disabled="application.frozen || $store.state.loadingApp > 0 || checkApplicationBeforeDelete(application.id) !== 'ok'"
                        v-on="on"
                        @click="appIdToDelete = application.id, confirmDeleteAppDialog = true"
                      >
                        <span
                          v-if="checkApplicationBeforeDelete(application.id) !== 'ok'"
                          class="white--text"
                        >
                          <v-icon
                            color="white"
                          >
                            $vuetify.icons.icon_mdi_delete_off
                          </v-icon>
                          {{ checkApplicationBeforeDelete(application.id) }}
                        </span>
                        <span
                          v-else
                          class="white--text"
                        >
                          <v-icon
                            color="white"
                          >
                            $vuetify.icons.icon_mdi_delete
                          </v-icon>
                          Remove the Application
                        </span>
                      </v-btn>
                    </template>
                    <span>Remove the Application and all its Services and Resources</span>
                  </v-tooltip>
                  <!-- <v-tooltip
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        white
                        small
                        class="ml-4 mt-2"
                        style="color: white;"
                        :disabled="$store.state.loadingApp > 0"
                        color="#7c9b7d"
                        @click="duplicateApplication(application.id)"
                      >
                        <v-icon>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </template>
                      <span>Duplicate the Application for {{ updatedClient.full_name }}</span>
                  </v-tooltip> -->
                </div>
              </v-card>
             

              <!-- NEW PART END -->
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-divider />
      <v-card-actions>
        <v-card-subtitle>
          client nr: {{ updatedClient.id }} <span v-if="client && client.lastChangedByName"> Last change by {{ client.lastChangedByName }}</span>
        </v-card-subtitle>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="dialogAddType"
      max-width="320px"
    >
      <v-card class="ppc_grey pt-2 rounded-xl">
        <v-card-title>
          <span>Select a type of Service</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-list
            rounded
            class="ppc_grey"
          >
            <v-list-item-group v-model="type">
              <v-list-item
                v-for="(type, i) in getListOfServicesTypes()"
                :key="i"
                @click="create_select_items(type.id)"
              >
                <div class="d-flex flex-row flex-wrap">
                  <v-list-item-icon>
                    <v-icon v-text="type.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="type.text" />
                  </v-list-item-content>
                </div>
              </v-list-item>
              <v-list-item
                v-if="updatedClient.agency_id"
                @click="create_select_items('agency')"
              >
                <v-list-item-icon>
                  <v-icon>$vuetify.icons.icon_mdi_domain</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="updatedClient.agency" />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogAddType = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="dialogSelectService"
      max-width="800px"
      scrollable
      rounded
    >
      <v-card class="ppc_grey pt-2 rounded-xl">
        <div class="d-flex flex-row justify-space-between">
          <v-card-title>
            <span
              v-if="select_items && select_items[0]"
              class="d-flex flex-row headline"
            >
              <v-icon
                class="ml-6"
                v-text="select_items[0].icon"
              />
              <span class="mx-2">{{ select_items[0].type }}</span>
            </span>
          </v-card-title>
          <div
            style="width: 70%"
            class="mx-8 mt-2"
          >
            <v-select
              v-model="selectedApplicationId"
              :items="listOfApplications"
              item-text="appTitle"
              item-value="id"
              :menu-props="{ auto: true }"
              label="New Application"
              single-line
              validate-on-blur
              color="white"
              clearable
            />
          </div>
        </div>
        <v-divider />
        <v-card-text style="height: 80vh;">
          <div
            v-for="select_item in select_items"
            :key="select_item.service_number"
            class="d-flex flex-row pa-2 ma-2 rounded-xl"
          >
            <v-card-text class="d-flex flex-row ma-0 pa-0 rounded-xl justify-space-between">
              <v-img
                :src="getImage(select_item.image)"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                max-width="200px"
                max-height="150px"
                rounded-xl
              >
                <v-card-title class="white--text">
                  {{ select_item.name }}
                </v-card-title>
              </v-img>
              <div
                class="ma-4"
                style="max-width: 400px;"
              >
                <div
                  v-if="select_item.desc_incl"
                  class="my-0 py-0"
                >
                  <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0">
                    Includes
                  </v-card-subtitle>
                  <v-card-text
                    class="pb-0"
                    v-html="select_item.desc_incl"
                  />
                </div>
              </div>
              <v-btn
                class="ma-4 align-self-center"
                color="ppc_darkgreen"
                @click="selectService(select_item.service_number)"
              >
                Add
              </v-btn>
            </v-card-text>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialogSelectService=false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_add_resource"
      :retain-focus="false"
      max-width="320px"
    >
      <v-form ref="dialogForm">
        <v-card>
          <v-card-title class="blue">
            <span class="headline white--text">Add Resource</span>
          </v-card-title>
          <v-card-text>
            <v-list-item-group
              v-model="type"
              color="primary"
            >
              <v-list-item
                v-for="(resource, i) in resource_types"
                :key="i"
                @click="addProvider(resource.type_id)"
              >
                <v-list-item-icon>
                  <v-icon v-text="resource.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="resource.text" />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue"
              text
              @click="dialog_add_resource = !dialog_add_resource"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-row justify="center">
      <v-dialog
        v-model="confirmDeleteResourceDialog"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title>
            Are you sure you want to remove this resource?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="confirmDeleteResourceDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="deleteResource()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-snackbar
      v-model="alertUploading"
      :timeout="timeout"
      top
      color="success"
    >
      <v-progress-linear
        v-model="progressAdvance"
        color="ppc_grey"
        height="15"
        reactive
      />
    </v-snackbar>

    <v-row justify="center">
      <v-dialog
        v-model="confirmDeleteClientDialog"
        persistent
        max-width="300px"
      >
        <v-card>
          <v-card-title>
            Are you sure you want to remove this client?
          </v-card-title>
          <v-card-text>All information, services and applications of {{ updatedClient.full_name }} will be removed from the system!</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="confirmDeleteClientDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="deleteClient()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    
    <v-row justify="center">
      <v-dialog
        v-model="confirmDeleteAppDialog"
        persistent
        max-width="300px"
      >
        <v-card>
          <v-card-title>
            Are you sure you want to remove the application?
          </v-card-title>
          <v-card-text>
            Removing will result in deleting the application, services and resources from the system.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="confirmDeleteAppDialog = false, appIdToDelete = null"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="deleteApplication()"
            >
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="confirmDeleteServiceDialog"
        persistent
        max-width="500"
        rounded
      >
        <v-card>
          <v-card-title v-if="services.filter(s => s.id === serviceIdToDelete)[0]">
            Are you sure you want to remove {{ services.filter(s => s.id === serviceIdToDelete)[0].name }} ?
          </v-card-title>
          <v-card-subtitle class="mt-1">
            This service and it's resources will be removed from the system!
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="confirmDeleteServiceDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="deleteService()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="confirmMoveServiceDialog"
        persistent
        max-width="400"
      >
        <v-card
          flat
          class="pa-3"
        >
          <v-card-title>
            Are you sure to move?
          </v-card-title>
          <v-card-subtitle>
            Moving this service will remove the application.
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="confirmMoveServiceDialog = false, serviceToMove = null"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="moveServiceNow()"
            >
              Move
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    
    <v-dialog
      v-model="selectApplicationDialog"
      max-width="900"
    >
      <v-card>
        <v-card-title>
          Move the Service to an Application
        </v-card-title>
        <v-btn
          class="ma-6"
          :disabled="onlyServiceInApp"
          @click="selectApplicationDialog = false, moveServiceToNewApp(serviceToMove)"
        >
          <h4>Create New Application</h4>
        </v-btn>
        <div class="d-flex flex-row flex-wrap justify-space-between">
          <h4
            class="ma-6"
          >
            Move to Existing Application
          </h4>
          <v-card flat>
            <v-text-field
              v-model="searchApplications"
              append-icon="$vuetify.icons.icon_mdi_magnify"
              :label="'Search ' + `${ applicationsSelect.length }` + ' application(s)'"
              single-line
              hide-details
              style="width: 300px"
              clearable
            />
          </v-card>
        </div>
        <v-card-text>
          <v-data-table
            :headers="headersSelectApp"
            hide-default-header
            :items="applicationsSelect"
            sort-by="nr"
            group-by="group"
            group-desc
            dense
            :items-per-page="-1"
            disable-pagination
            hide-default-footer
            :search="searchApplications"
          >
            <template v-slot:group="props">
              <span class="font-weight-bold">
                {{ props.group }}
              </span>
              <v-data-table
                :headers="props.headers"
                :items="props.items"
                dense
                :items-per-page="-1"
                disable-pagination
                hide-default-footer
                @click:row="prepMoveService($event)"
              >
                <template v-slot:[`item.applied`]="{ item }">
                  {{ formattedDate(item.applied, 'Noday') }}
                </template>
              </v-data-table>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="selectApplicationDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEditClientBasic"
      min-width="300"
      max-width="70vw"
    >
      <v-form ref="formClient">
        <v-card
          flat
          rounded="xl"
        >
          <v-card
            flat
            class="d-flex flex-row flex-wrap pa-4"
          >
            <v-card
              class="ma-4 pa-4 rounded-xl"
              style="max-width: 400px"
            >
              <v-card-title>
                Client
              </v-card-title>
              <v-card-text>
                <span v-if="editClient.number_people === null">
                  <v-text-field
                    v-model.trim="editClient.first_name"
                    label="First name"
                    prepend-icon="$vuetify.icons.icon_mdi_smart_card ppc_darkgreen--text"
                    validate-on-blur
                    :error-messages="errorMessageNames"
                    :rules="inputRulesName"
                    required
                  />
                  <v-spacer />
                  <v-text-field
                    v-model.trim="editClient.last_name"
                    label="Last name"
                    prepend-icon="$vuetify.icons.icon_mdi_smart_card-outline ppc_darkgreen--text"
                    validate-on-blur
                    :error-messages="errorMessageNames"
                    :rules="inputRulesName"
                  />
                </span>
                <span v-if="editClient.number_people !== null">
                  <v-text-field
                    v-model.trim="editClient.last_name"
                    label="Name"
                    prepend-icon="$vuetify.icons.icon_mdi_smart_card-outline ppc_darkgreen--text"
                    validate-on-blur
                    :error-messages="errorMessageNames"
                    :rules="inputRulesName"
                  />
                </span>
                <span v-if="editClient.number_people === null">
                  <v-menu 
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        :value="formattedDate(editClient.birthdate)" 
                        label="Date of birth" 
                        v-bind="attrs" 
                        prepend-icon="mdi-cake-variant ppc_darkgreen--text"
                        clearable
                        readonly
                        v-on="on"
                        @click:clear="editClient.birthdate=null"
                      />
                    </template>
                    <v-date-picker 
                      v-model="editClient.birthdate"
                      color="ppc_darkgreen"
                      scrollable
                    />
                  </v-menu>
                </span>
                <v-spacer />
                <span v-if="editClient.number_people === null">
                  <v-select
                    v-model="editClient.gender"
                    :items="itemsSex"
                    :menu-props="{ auto: true }"
                    item-text="Text"
                    item-value="Value"
                    label="Gender"
                    single-line
                    validate-on-blur
                  >
                    <template v-slot:item="itemsSex">
                      <span v-if="itemsSex.item.Value === 'Male'"><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-male</v-icon> {{ itemsSex.item.Text }} </span>
                      <span v-else-if="itemsSex.item.Value === 'Female'"><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-female</v-icon> {{ itemsSex.item.Text }} </span>
                      <span v-else><v-icon
                        small
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-genderless</v-icon> {{ itemsSex.item.Text }} </span>
                    </template>
                    <template v-slot:selection="itemsSex">
                      <span v-if="itemsSex.item.Value === 'Male'"><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-male</v-icon></span>
                      <span v-else-if="itemsSex.item.Value === 'Female'"><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-female</v-icon></span>
                      <span v-else><v-icon
                        color="ppc_darkgreen"
                        class="mr-4"
                      >fa-genderless</v-icon></span>
                    </template>
                  </v-select>
                </span>
                <v-spacer />
                <v-select
                  v-model="editClient.nationality_id"
                  :items="$store.state.itemsNationality"
                  item-text="nationality"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Select nationality"
                  single-line
                  prepend-icon="mdi-earth ppc_darkgreen--text"
                  validate-on-blur
                />
                <span>
                  <v-text-field
                    v-model.trim="editClient.occupation"
                    label="Occupation (in Spanish)"
                    prepend-icon="mdi-account-hard-hat ppc_darkgreen--text"
                    validate-on-blur
                    clearable
                  />
                </span>
              </v-card-text>
            </v-card>
            <v-card
              class="ma-4 pa-4 rounded-xl"
              style="width: 400px"
            >
              <v-card-title>
                Contact info
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model.trim="editClient.email"
                  label="Email (login PM)"
                  prepend-icon="mdi-email ppc_darkgreen--text"
                  :error-messages="errorMessageEmail"
                  :rules="inputRulesEmail"
                  validate-on-blur
                  clearable
                />
                <v-text-field
                  v-model.trim="editClient.email_cc"
                  label="Email cc/agency"
                  prepend-icon="fas fa-copy ppc_darkgreen--text"
                  :rules="inputRulesEmail"
                  validate-on-blur
                  clearable
                />
                <v-text-field
                  v-model.trim="editClient.phone"
                  label="Phone"
                  prepend-icon="mdi-cellphone ppc_darkgreen--text"
                  :rules="inputRulesPhone"
                  validate-on-blur
                />
                <v-text-field
                  v-model.trim="editClient.phone_alt"
                  label="Alternative phone"
                  prepend-icon="mdi-phone ppc_darkgreen--text"
                  :rules="inputRulesPhone"
                  validate-on-blur
                />
              </v-card-text>
            </v-card>
            <v-card
              class="ma-4 pa-4 rounded-xl"
              style="max-width: 400px"
            >
              <v-card-title>Source</v-card-title>
              <v-card-text>
                <v-card
                  v-if="editClient.agency_id !== null"
                  flat
                >
                  Agency: {{ editClient.agency }}
                </v-card>
                <v-select
                  v-if="editClient.source_id !== null"
                  v-model="editClient.source_id"
                  :items="$store.state.itemsSources.sort(this.dynamicSort('name'))"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Select source"
                  single-line
                  prepend-icon="fab fa-sourcetree ppc_darkgreen--text"
                  validate-on-blur
                />
              </v-card-text>
            </v-card>
            <v-card
              class="ma-4 pa-4 rounded-xl"
              style="max-width: 400px"
            >
              <v-card flat>
                <v-card-title>
                  <v-icon
                    color="ppc_darkgreen"
                    class="mr-2"
                  >
                    mdi-food-apple
                  </v-icon>
                  Food preference
                </v-card-title>
                <v-card-text>
                  <v-radio-group
                    v-model="editClient.food_preference"
                    cols="12"
                    column
                    class="mt-0"
                  >
                    <v-radio
                      label="Not known"
                      value="Not known"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="I have no dietary restrictions"
                      value="I am not vegetarian neither vegan"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="I am vegetarian"
                      value="I am vegetarian"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="I am vegan"
                      value="I am vegan"
                      class="my-0 py-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </v-card>
              <v-card flat>
                <v-card-title>
                  <v-icon
                    color="ppc_darkgreen"
                    class="mr-2"
                  >
                    mdi-dog-side
                  </v-icon>
                  Pets preference
                </v-card-title>
                <v-card-text>
                  <v-radio-group
                    v-model="editClient.pets_preference"
                    cols="12"
                    column
                    class="mt-0"
                  >
                    <v-radio
                      label="Not known"
                      value="Not known"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="I do not mind pets"
                      value="I do not mind pets"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="No pets please"
                      value="No pets please"
                      class="my-0 py-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-card>
            <v-card
              class="rounded-xl ma-4 pa-4"
              style="max-width: 800px"
            >
              <v-card-title>
                Pick Up Data
              </v-card-title>
              <v-radio-group
                v-model="editClient.pickup_type"
                row
                class="mt-0 mx-4"
              >
                <v-radio
                  label="To be confirmed"
                  value="To be confirmed"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Flight"
                  value="Flight"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Bus"
                  value="Bus"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Address Cusco"
                  value="Address"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Not applicable"
                  value="Not applicable"
                  class="my-0 py-0"
                />
              </v-radio-group>
              <v-card
                flat
                class="d-flex flex-row flex-wrap"
              >
                <v-card flat>
                  <v-text-field 
                    v-if="editClient.pickup_type !== 'Address'" 
                    v-model.trim="editClient.pickup_company" 
                    label="Company" 
                    prepend-icon="$vuetify.icons.icon_mdi_domain ppc_darkgreen--text"
                    clearable
                    class="pa-2"
                  />
                </v-card>
                <v-card flat>
                  <v-text-field 
                    v-if="editClient.pickup_type === 'Flight'" 
                    v-model.trim="editClient.pickup_nr" 
                    label="Flight nr" 
                    prepend-icon="mdi-airplane ppc_darkgreen--text" 
                    clearable
                    class="pa-2"
                  />
                </v-card>
                <v-card flat>
                  <v-text-field 
                    v-if="editClient.pickup_type !== 'Address'" 
                    v-model.trim="editClient.pickup_from" 
                    label="From" 
                    prepend-icon="$vuetify.icons.icon_mdi_map_marker" 
                    clearable
                    class="pa-2"
                  />
                </v-card>
                <v-textarea
                  v-if="editClient.pickup_type === 'Address'"
                  v-model="editClient.pickup_address"
                  style="min-width: 200px"
                  class="rounded-xl pa-2"
                  auto-grow
                  clearable
                  outlined
                  counter="150"
                  rows="2"
                  label="Address in Cusco (150 max)"
                  :rules="[v => (v || '' ).length <= 150 || 'Comments must be 150 characters or less']"
                  prepend-icon="$vuetify.icons.icon_mdi_map_marker"
                />
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="arrival"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar ppc_darkgreen--text"
                      :value="formattedDate(editClient.pickup_date)"
                      clearable
                      readonly
                      class="pa-2"
                      v-on="on"
                      @click:clear="editClient.pickup_date=null"
                    />
                  </template>
                  <v-date-picker
                    v-model="editClient.pickup_date"
                    no-title
                    scrollable
                  />
                </v-menu>
                <v-card flat>
                  <v-text-field
                    :value="editClient.pickup_time ? editClient.pickup_time.slice(0, 5) : ''"
                    label="Time (hh:mm)"
                    prepend-icon="mdi-clock-time-nine-outline ppc_darkgreen--text"
                    clearable
                    class="pa-2"
                    @input="editClient.pickup_time = $event"
                  />
                </v-card>
              </v-card>
            </v-card>
            <v-card
              class="rounded-xl ma-4 pa-4"
              style="max-width: 600px"
            >
              <v-card-title>
                Emergency Contact
              </v-card-title>
              <v-text-field
                v-model.trim="editClient.ice_full_name"
                label="Full name"
                prepend-icon="$vuetify.icons.icon_mdi_smart_card ppc_darkgreen--text"
              />
              <v-text-field
                v-model.trim="editClient.ice_email"
                label="Email"
                prepend-icon="mdi-email ppc_darkgreen--text"
                :rules="inputRulesEmail"
                validate-on-blur
              />
              <v-text-field
                v-model.trim="editClient.ice_phone"
                label="Phone"
                prepend-icon="mdi-cellphone ppc_darkgreen--text"
                :rules="inputRulesPhone"
                validate-on-blur
              />
              <v-text-field
                v-model.trim="editClient.ice_phone_alt"
                label="Alternative phone"
                prepend-icon="mdi-phone ppc_darkgreen--text"
                :rules="inputRulesPhone"
                validate-on-blur
              />
            </v-card>
            <div class="d-flex flex-column">
              <v-textarea
                v-model="editClient.comments"
                class="rounded-xl ma-4"
                auto-grow
                clearable
                counter="500"
                outlined
                label="Comments (500 max)"
                :rules="[v => (v || '' ).length <= 500 || 'Comments must be 500 characters or less']"
                style="min-width: 400px"
              />
              <v-textarea
                v-model="editClient.expectations"
                class="rounded-xl ma-4"
                auto-grow
                clearable
                counter="500"
                outlined
                label="Expectations (500 max)"
                :rules="[v => (v || '' ).length <= 500 || 'Expectations must be 500 characters or less']"
                style="min-width: 400px"
              />
              <v-textarea
                v-model="editClient.experience"
                class="rounded-xl ma-4"
                auto-grow
                clearable
                counter="500"
                outlined
                label="Experience (500 max)"
                :rules="[v => (v || '' ).length <= 500 || 'Experience must be 500 characters or less']"
                style="min-width: 400px"
              />
            </div>
          </v-card>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="mr-4"
              large
              text
              @click="dialogEditClientBasic = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="mr-4"
              large
              text
              @click="saveClient('info')"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    
    <!-- <v-dialog v-model="dialogIncomeDelete" max-width="500px">
        <v-card>
            <v-card-title>Are you sure you want to remove the payment?</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="ppc_darkgreen darken-1" text @click="dialogIncomeDelete = !dialogIncomeDelete">Cancel</v-btn>
                <v-btn color="ppc_darkgreen darken-1" text @click="deleteIncomeConfirm" :loading="loadingButton">OK</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog> -->

    <v-dialog
      v-model="dialogService"
      max-width="60vw"
    >
      <v-card
        flat
        class="d-flex flex-column"
        color="ppc_grey"
        rounded="xl"
      >
        <v-card
          flat
          class="d-flex flex-row pa-2"
          color="ppc_grey"
        >
          <!-- image & description -->
          <v-card
            flat
            class="mx-0 my-3 mx-sm-3 rounded-xl"
            max-width="450px"
            color="#eee"
          >
            <v-card-text>
              <v-img
                :src="getImage(updatedService.image)"
                class="white--text align-end mb-5"
                height="100%"
                width="100%"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
                <v-card-title
                  class="white--text"
                  v-text="updatedService.name"
                />
              </v-img>
              <div v-if="updatedService.servicePrice">
                <p
                  flat
                >
                  <v-card-title class="ppc_darkgreen--text">
                    Price
                  </v-card-title>
                  <v-card-text class="pb-0">
                    <strong>
                      <div v-if="updatedService.servicePrice">&nbsp;{{ updatedService.currency }}{{ decUtil.format(updatedService.servicePrice) }} </div>
                      <div v-if="updatedService.currency === 'S/.'">
                        (${{ decUtil.format(decUtil.toUSD(updatedService.servicePrice, updatedService.currency, $store.state.exchangeRate)) }})
                      </div>
                    </strong>
                  </v-card-text>
                </p>
                <v-divider />
              </div>
              <p v-if="updatedService.min_duration">
                <v-card-subtitle class="ppc_darkgreen--text">
                  Minimal duration
                </v-card-subtitle>
                <v-card-text> 
                  {{ updatedService.min_duration }} {{ updatedService.duration_text }} 
                  <v-divider /> 
                </v-card-text>
              </p>
              <p v-if="updatedService.min_level_spanish">
                <v-card-subtitle class="ppc_darkgreen--text">
                  Initial Spanish level
                </v-card-subtitle>
                <v-card-text> {{ updatedService.min_level_spanish }} <v-divider /> </v-card-text>
              </p>
              <p v-if="updatedService.duration_type === 'fixed'">
                <v-card-subtitle class="ppc_darkgreen--text">
                  Duration
                </v-card-subtitle>
                <v-card-text>{{ updatedService.duration }} {{ updatedService.duration_text }} </v-card-text>
                <v-divider />
              </p>
              <div v-if="updatedService.desc_acc">
                <p
                  flat
                >
                  <v-card-subtitle class="ppc_darkgreen--text">
                    Accommodation
                  </v-card-subtitle>
                  <v-card-text
                    class="pb-0"
                    v-html="updatedService.desc_acc"
                  />
                </p>
                <v-divider />
              </div>
              <div v-if="updatedService.desc_study">
                <p
                  flat
                >
                  <v-card-subtitle class="ppc_darkgreen--text">
                    Study
                  </v-card-subtitle>
                  <v-card-text
                    class="pb-0"
                    v-html="updatedService.desc_study"
                  />
                </p>
                <v-divider />
              </div>
              <div v-if="updatedService.desc_project">
                <p
                  flat
                >
                  <v-card-subtitle class="ppc_darkgreen--text">
                    Project
                  </v-card-subtitle>
                  <v-card-text
                    class="pb-0"
                    v-html="updatedService.desc_project"
                  />
                </p>
                <v-divider />
              </div>
              <div v-if="updatedService.desc_start">
                <p
                  flat
                >
                  <v-card-subtitle class="ppc_darkgreen--text">
                    Start
                  </v-card-subtitle>
                  <v-card-text
                    class="pb-0"
                    v-html="updatedService.desc_start"
                  />
                </p>
                <v-divider />
              </div>
              <div v-if="updatedService.desc_incl">
                <p
                  flat
                >
                  <v-card-subtitle class="ppc_darkgreen--text">
                    Includes
                  </v-card-subtitle>
                  <v-card-text
                    class="pb-0"
                    v-html="updatedService.desc_incl"
                  />
                </p>
                <v-divider />
              </div>
            </v-card-text>
          </v-card>
          <div>
            <!-- Period & dates -->
            <v-card 
              v-if="updatedService.allowedStartDays" 
              elevation="3"
              class="mx-0 my-3 mx-sm-3 pa-4 float-left rounded-xl"
              max-width="250px"
              :disabled="updatedService.frozen"
            >
              <v-card-title>Period</v-card-title>
              <v-card-text>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="from"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(updatedServiceStart)"
                      :disabled="!updatedService.service_number"
                      clearable
                      readonly
                      v-on="on"
                      @click:clear="clearStartDate(), updatedService.serviceNotChanged = false"
                      @click="changeAllowedStartDays(updatedService.service_number), updatedService.serviceNotChanged = false"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedServiceStart"
                    no-title
                    scrollable
                    :allowed-dates="getStartDays"
                    @change="updatedService.start = updatedServiceStart, updatedService.end = updatedServiceEnd, calcDatesServices('start')"
                  />
                </v-menu>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="until"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(updatedServiceEnd)"
                      :disabled="disabledEndDate(updatedService.id)"
                      clearable
                      readonly
                      v-on="on"
                      @click:clear="clearEndDate(), updatedService.serviceNotChanged = false"
                      @click="changeAllowedEndDays(updatedService.service_number), updatedService.serviceNotChanged = false"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedServiceEnd"
                    no-title
                    scrollable
                    :allowed-dates="getEndDays"
                    :min="getMinEndDate()"
                    :show-current="getMinEndDate()"
                    @change="updatedService.start = updatedServiceStart, updatedService.end = updatedServiceEnd, calcDatesServices('end')"
                  />
                </v-menu>
                <v-slider
                  v-model="updatedService.duration"
                  step="1"
                  ticks
                  tick-size="4"
                  v-if="updatedService.week_slider"
                  thumb-label="always"
                  :min="updatedService.min_duration"
                  :max="updatedService.week_slider"
                  :hint="updatedService.duration_text"
                  persistent-hint
                  thumb-color="ppc_pink"
                  track-color="ppc_grey"
                  :disabled="!updatedService.service_number"
                  class="mt-8"
                  @change="calcDatesServices('duration'), updatedService.serviceNotChanged = false"
                />
              </v-card-text>
            </v-card>

            <!-- radiogroups in services -->

            <v-card
              v-if="updatedRadioGroups_filtered(updatedService.id).length > 0"
              flat
              :disabled="updatedService.frozen"
            >
              <v-card
                v-for="radio_group in updatedRadioGroups_filtered(updatedService.id)"
                :key="radio_group.radio_group_id + '-' + radio_group.services_id"
                flat
                class="mx-0 my-3 mx-sm-3 float-left rounded-xl"
              >
                <v-card
                  elevation="3"
                  class="pa-4"
                >
                  <v-card-title>
                    {{ radio_group.radio_group_question }}
                  </v-card-title>
                  <v-card-text>
                    <v-radio-group
                      v-model="radio_group.radio_group_value"
                      column
                      @change="calcDatesServices('duration', radio_group), updatedService.serviceNotChanged = false"
                    >
                      <v-radio
                        v-for="radio_option in radioOptions_filtered(radio_group)"
                        :key="radio_option.id"
                        :label="radio_option.label"
                        :value="radio_option.label"
                        class="my-0 py-0"
                      />
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card>
                
            <!-- options in services -->

            <v-card 
              v-if="updatedOptions_filtered(updatedService.id).length > 0"
              elevation="3"
              class="mx-0 my-3 mx-sm-3 float-left rounded-xl"
              :disabled="updatedService.frozen"
            >
              <v-card-title>
                Options
              </v-card-title>
              <v-card-text>
                <v-card
                  v-for="option in updatedOptions_filtered(updatedService.id)"
                  :key="option.option_id + '-' + option.services_id"
                  flat
                >
                  <v-checkbox
                    v-model="option.selected"
                    :label="option.option_question"
                    class="my-0 py-0"
                    @change="calcDatesServices('duration'), updatedService.serviceNotChanged = false"
                  />
                </v-card>
              </v-card-text>
            </v-card>
          </div>
        </v-card>
        <v-card-actions>
          <v-card-subtitle>
            Service id:{{ updatedService.id }} <span v-if="updatedService && updatedService.lastChangedByName"> Last change by {{ updatedService.lastChangedByName }}</span>
          </v-card-subtitle>
          <v-spacer />
          <v-btn
            class="mr-4"
            text
            @click="dialogService = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="mr-4"
            text
            :disabled="$store.state.loadingApp > 0 || updatedService.frozen"
            @click="saveService()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogResource"
      max-width="500px"
    >
      <v-card
        class="d-flex flex-column pa-2"
        color="blue"
        rounded="xl"
      >
        <div v-if="updatedResource.type_id === 1 || updatedResource.type_id === 2">
          <v-card-title>
            <span
              v-if="updatedResource.type_id === 1"
              class=" white--text"
            >Volunteer Placement #{{ updatedResource.number_type }}</span>
            <span
              v-if="updatedResource.type_id === 2"
              class=" white--text"
            >Internship Placement #{{ updatedResource.number_type }}</span>
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="updatedResource.category_id"
              :items="categoriesProjects(updatedResource.type_id)"
              item-text="category"
              item-value="category_id"
              :menu-props="{ auto: true }"
              label="Category"
              validate-on-blur
              clearable
              color="white"
              item-color="blue"
              :disabled="updatedResource.placement_id !== null"
              @click:clear="updatedResource.project_id = null, updatedResource.placement_id = null, updatedResource.payment = null, updatedResource.donation = null, updatedResource.donation_type = null"
              @change="updatedResource.project_id = null, updatedResource.placement_id = null, updatedResource.payment = null, updatedResource.donation = null, updatedResource.donation_type = null"
            >
              <template #selection="{ item }">
                <span class="white--text">{{ item.category }}</span>
              </template>
            </v-select>
            <v-select
              v-model="updatedResource.project_id"
              :items="filterProjects(updatedResource.type_id, updatedResource.category_id, updatedResource.project_id)"
              item-text="name"
              item-value="id"
              :menu-props="{ auto: true }"
              label="Project"
              validate-on-blur
              clearable
              color="white"
              item-color="blue"
              :disabled="updatedResource.placement_id !== null"
              @click:clear="updatedResource.project_id = null, updatedResource.placement_id = null, updatedResource.payment = null, updatedResource.donation = null, updatedResource.donation_type = null"
              @change="updatedResource.placement_id = null, updatedResource.payment = null, updatedResource.donation = null, updatedResource.donation_type = null, updatedResource.category_id = filterProjects(updatedResource.type_id, 
                                                                                                                                                                                                                updatedResource.category_id, updatedResource.project_id)[0].category_id"
            >
              <template #selection="{ item }">
                <span class="white--text">{{ item.name }}</span>
              </template>
            </v-select>
          </v-card-text>
        </div>

        <div v-if="updatedResource.type_id === 3 || updatedResource.type_id === 8">
          <v-card-title>
            <span class="white--text">{{ updatedResource.class_language }} Course #{{ updatedResource.number_type }}</span>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-row flex-wrap">
              <div class="d-flex flex-row flex-wrap">
                <v-radio-group
                  v-model="updatedResource.class_language"
                  cols="12"
                  column
                  class="mt-0 mr-6"
                  :disabled="updatedResource.minutes_planned > 0"
                  v-if="updatedResource.type_id === 3"
                >
                  <v-radio
                    label="Spanish"
                    value="Spanish"
                    class="my-0 py-0"
                    color="white"
                  />
                  <v-radio
                    label="Quechua"
                    value="Quechua"
                    class="my-0 py-0"
                    color="white"
                  />
                </v-radio-group>
                <v-radio-group
                  v-model="updatedResource.class_location"
                  cols="12"
                  column
                  class="mt-0 mr-6"
                  :disabled="updatedResource.minutes_planned > 0"
                >
                  <v-radio
                    label="Cusco School"
                    value="School Cusco"
                    class="my-0 py-0"
                    color="white"
                  />
                  <v-radio
                    label="Urubamba"
                    value="Urubamba"
                    class="my-0 py-0"
                    color="white"
                  />
                  <v-radio
                    label="Online"
                    value="Online"
                    class="my-0 py-0"
                    color="white"
                  />
                </v-radio-group>
              </div>
              <div class="d-flex flex-row flex-wrap">
                <v-radio-group
                  v-model="updatedResource.class_type"
                  cols="12"
                  column
                  class="mt-0 mr-6"
                  :disabled="updatedResource.minutes_planned > 0"
                >
                  <v-radio
                    label="Normal"
                    value="Normal"
                    class="my-0 py-0"
                    color="white"
                  />
                  <v-radio
                    label="Specialism"
                    value="Special"
                    class="my-0 py-0"
                    color="white"
                  />
                </v-radio-group>
                <v-radio-group
                  v-model="updatedResource.class_group"
                  cols="12"
                  column
                  class="mt-0 mr-6"
                  :disabled="updatedResource.minutes_planned > 0"
                >
                  <v-radio
                    label="Group"
                    value="Group"
                    class="my-0 py-0"
                    color="white"
                  />
                  <v-radio
                    label="Individual"
                    value="Individual"
                    class="my-0 py-0"
                    color="white"
                  />
                </v-radio-group>
              </div>
            </div>
            <v-card-text>
              <v-text-field
                v-model="updatedResource.hours"
                label="Hours sold"
                class="text-input-white"
                color="white"
              />
              <v-text-field
                v-model="updatedResource.hours_per_class"
                label="Hours per class"
                class="text-input-white"
                color="white"
              />
            </v-card-text>
          </v-card-text>
        </div>

        <div v-if="updatedResource.type_id === 4">
          <v-card-title>
            <span class=" white--text">Accommodation #{{ updatedResource.number_type }}</span> 
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-row flex-wrap justify-space-between">
              <v-radio-group
                v-model="updatedResource.family"
                cols="12"
                column
                class="mt-0"
                :disabled="updatedResource.room_id !== null"
                @change="updatedResource.private_bathroom = 0"
              >
                <v-radio
                  label="Family"
                  value="1"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Apartment"
                  value="0"
                  class="my-0 py-0"
                  color="white"
                />
              </v-radio-group>
              <v-radio-group
                v-model="updatedResource.accommodation_class"
                cols="12"
                column
                class="mt-0"
                :disabled="updatedResource.room_id !== null"
                @change="updatedResource.private_bathroom = 0"
              >
                <v-radio
                  label="Private Room"
                  value="Private Room"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Private Double"
                  value="Private Double"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Private Twin"
                  value="Private Twin"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Shared Room"
                  value="Shared Room"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Shared Bunk"
                  value="Shared Bunk"
                  class="my-0 py-0"
                  :disabled="updatedResource.family == 1"
                  color="white"
                />
              </v-radio-group>
              <v-checkbox
                v-model="updatedResource.private_bathroom"
                label="Private Bathroom"
                class="mr-4 mt-0"
                color="white"
                :disabled="updatedResource.room_id !== null || updatedResource.accommodation_class === 'Shared Room' || updatedResource.accommodation_class === 'Shared Bunk'"
              />
            </div>
          </v-card-text>
        </div>

        <div v-if="updatedResource.type_id === 5">
          <v-card-title>
            <span class=" white--text">Tour #{{ updatedResource.number_type }}</span>
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="updatedResource.tour_id"
              :items="tourSelect"
              item-text="name"
              item-value="id"
              :menu-props="{ auto: true }"
              label="Tour"
              validate-on-blur
              clearable
              color="white"
              item-color="blue"
              :disabled="updatedResource.tour_placement_id !== null"
            >
              <template #selection="{ item }">
                <span class="white--text">{{ item.name }}</span>
              </template>
            </v-select>
          </v-card-text>
        </div>
        
        <v-card-text>
          <v-btn
            x-small
            class="pa-4 ma-4"
            @click="copyDatesFromService()"
          >
            copy dates from service
          </v-btn>
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            class="my-5"
            max-width="100%"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="from"
                v-bind="attrs"
                prepend-icon="$vuetify.icons.icon_mdi_calendar"
                :value="formattedDate(updatedResourceStart)"
                clearable
                readonly
                class="text-input-white"
                color="white"
                :disabled="((updatedResource.type_id === 1 || updatedResource.type_id === 2) && updatedResource.placement_id !== null) || ((updatedResource.type_id === 3 || updatedResource.type_id === 8) && updatedResource.minutes_planned > 0) || (updatedResource.type_id === 4 && updatedResource.room_id !== null) || (updatedResource.type_id === 5 && updatedResource.tour_placement_id !== null)"
                v-on="on"
                @click:clear="updatedResource.start = null, updatedResourceStart = null, calcDatesResource('start')"
              />
            </template>
            <v-date-picker
              v-model="updatedResourceStart"
              no-title
              scrollable
              color="blue"
              @change="updatedResource.start = updatedResourceStart, updatedResource.end = updatedResourceEnd, calcDatesResource('start')"
            />
          </v-menu>
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            class="my-5"
            max-width="100%"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="until"
                v-bind="attrs"
                prepend-icon="$vuetify.icons.icon_mdi_calendar"
                :value="formattedDate(updatedResourceEnd)"
                clearable
                readonly
                class="text-input-white"
                color="white"
                :disabled="((updatedResource.type_id === 1 || updatedResource.type_id === 2) && updatedResource.placement_id !== null) || ((updatedResource.type_id === 3 || updatedResource.type_id === 8) && updatedResource.minutes_planned > 0) || (updatedResource.type_id === 4 && updatedResource.room_id !== null) || (updatedResource.type_id === 5 && updatedResource.tour_placement_id !== null)"
                v-on="on"
                @click:clear="updatedResource.end = null, updatedResourceEnd = null, calcDatesResource('end')"
              />
            </template>
            <v-date-picker
              v-model="updatedResourceEnd"
              no-title
              scrollable
              color="blue"
              @change="updatedResource.start = updatedResourceStart, updatedResource.end = updatedResourceEnd, calcDatesResource('end')"
            />
          </v-menu>
        </v-card-text>

        <div v-if="updatedResource.type_id === 1 || updatedResource.type_id === 2">
          <v-card-text>
            <v-slider
              v-model="updatedResource.businessWeeks"
              step="1"
              ticks
              tick-size="4"
              thumb-label="always"
              :min="1"
              :max="52"
              hint="Duration in weeks"
              persistent-hint
              thumb-color="ppc_pink"
              track-color="ppc_grey"
              color="white"
              class="my-8"
              :disabled="updatedResource.placement_id !== null"
              @change="calcDatesResource('duration')"
            />
          </v-card-text>
        </div>

        <v-card-text>
          <v-textarea
            v-model="updatedResource.comments"
            class="rounded-xl px-6"
            auto-grow
            clearable
            counter="255"
            outlined
            label="Comments (255 max)"
            :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
            color="white"
          />
        </v-card-text>

        <v-card-subtitle class="my-0 py-0">
          Service:
        </v-card-subtitle>
        <v-select
          v-model="updatedResource.service_id"
          style="width: 90%"
          :items="listOfServices"
          item-text="name"
          item-value="id"
          :menu-props="{ auto: true }"
          label="Service"
          single-line
          validate-on-blur
          class="align-self-center"
          color="white"
        />
        
        <v-card-actions
          class="d-flex flex-row flex-wrap justify-space-between"
          color="blue lighten-2"
          style="width: 100%"
        >
          #{{ updatedResource.id }} <span v-if="updatedResource && updatedResource.lastChangedByName"> Last change by {{ updatedResource.lastChangedByName }}</span>
          <v-spacer />
          <v-btn
            color="white"
            text
            @click="dialogResource = false, updatedResource = {}"
          >
            Cancel
          </v-btn>
          <v-btn
            color="white" 
            text
            @click="dialogResource = false, saveResource(updatedResource.id)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import getStatusApp from '../mixins/getStatusApp';
import createAppTitle from '../mixins/createAppTitle';
import compare from '../mixins/compare';
import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days';
dayjs.extend(dayjsBusinessDays);
import decUtil from '@/utils/decimalUtils';

export default {

  mixins: [inputRules, formattedDate, createAppTitle, getStatusApp, compare],
  
  data() {
    return {
      decUtil,
      updatedClient: [],
      editClient: [],
      services: [],
      updatedService: [],
      servicesInApp: [],
      servicesClientsList: [],
      applications: [],
      tab: (this.$route.params.resourceId) ? 1 : 0,
      errorMessageEmail: '',
      errorMessageNames: '',
      select_items: [],
      approvalDateCv: null,
      approvalDatePassport: null,
      dialogAddType: false,
      dialog_add_resource: false,
      type: null,
      dialogSelectService: false,
      itemsSex: [
        {Value: 'Female', Text: 'Female'},
        {Value: 'Male', Text: 'Male'},
        {Value: 'X', Text: 'Genderless'}
      ],
      currentFile: undefined,
      alertUploading: false,
      confirmDeleteClientDialog: false,
      confirmDeleteAppDialog: false,
      confirmDeleteServiceDialog: false,
      confirmDeleteResourceDialog: false,
      confirmMoveServiceDialog: false,
      selectApplicationDialog: false,
      applicationsNotStarted: [],
      headersSelectApp: [
        {text: 'App Title', value: 'appTitle', groupable: false},
        {text: 'payer', value: 'payer', groupable: false},
        {text: 'applied', value: 'applied', groupable: false, width: '120px' },
        {text: 'nr', value: 'id', groupable: false},
        {text: 'group', value: 'group', groupable: false},
      ],
      headersSecurityDeposits: [
        {text: 'date', value: 'dateTime'},
        {text: 'amount', value: 'amountDollars'},
      ],
      appIdToDelete: null,
      serviceIdToDelete: null,
      resourceIdToDelete: null,
      serviceToMove: null,
      serviceIdToResource: null,
      timeout: 3000,
      fileRules: [
        file => !file || file.size < 2e6 || 'File size should be less than 2 MB!'
      ],
      selectFileCV: false,
      selectFilePassport: false, 
      selectFileOther: false,
      resources: [],
      resource_types: [
        {icon: "$vuetify.icons.icon_volunteer", text:"Volunteer Placement", type_id: 1},
        {icon: "$vuetify.icons.icon_internship", text:"Internship Placement", type_id: 2},
        {icon: "$vuetify.icons.icon_languages", text:"Spanish Course", type_id: 3},
        {icon: "$vuetify.icons.icon_accommodation", text:"Accommodation", type_id: 4},
        {icon: "$vuetify.icons.icon_tours", text:"Tour Agency", type_id: 5},
        {icon: "$vuetify.icons.icon_languages", text:"English Course", type_id: 8},
      ],
      applicationsSelect: [],
      tourSelect: [],
      loadingButtonSynchronise: false,
      syncButtonPassport: false,
      syncButtonCV: false,
      addPaymentInfo: false,
      nowDate: null,
      securityDeposits: [],
      dialogService: false,
      dialogResource: false,
      updatedResource: {},
      updatedRadioGroups: [],
      updatedOptions: [],
      dragover: false,
      dialogEditClientBasic: false,
      initializing: false,
      school_welcome_email: 'spanish',
      changingResource: null,
      appIdNew: null,
      selectedApplicationId: null,
      onlyServiceInApp: false,
      searchApplications: '',
      savingClient: false,
      updatedServiceStart: null,
      updatedServiceEnd: null,
      updatedResourceStart: null,
      updatedResourceEnd: null,
      client: null,
      fileOther: null,
    }
  },

  computed: {
    statusLoggedOut () {
      return this.$store.getters.statusLoggedOut
    },
    // client () {
    //   return this.$store.getters.client
    // },
    progressAdvance () {
      return this.$store.getters.progressAdvance
    },
    uploadInfos () {
      return this.$store.getters.uploadInfos
    },
    noExistsServices () {
      let tmp = this.services.filter(function(select_item) {
        return select_item.application_id === null;
      })
      return (tmp.length === 0);
    },
    currentClient () {
      return this.$store.getters.currentClient
    },
    selectContactsStaff () {
      let staff = this.$store.state.contacts.filter(function(select_item) {
          return select_item.obsolete === null && select_item.staff > 0;
      })
      return staff.sort(this.dynamicSort('name'));
    },
    listOfServices () {
      let list = [];
      for (let index = 0; index < this.services.length; index++) {
        if (this.services[index].start && this.services[index].start !== null) {
          list.push({id: this.services[index].id, name: this.services[index].name + ' - ' + this.services[index].start});
        } else {
          list.push({id: this.services[index].id, name: this.services[index].name});
        }
      }
      return list;
    },
    listOfApplications () {
      let list = [];
      for (let index = 0; index < this.applications.length; index++) {
        list.push({id: this.applications[index].id, appTitle: '#' + (this.applications.length - index) + ' - ' + this.applications[index].appTitle});
      }
      // console.log('listOfApplications', list);
      return list;
    },
    calcAge () {
      return dayjs().diff(this.updatedClient.birthdate, 'year');
    },
    calcPMmessages () {
      let numberMessages = 0;
      if (this.updatedClient.id !== undefined) {
        let clientId = this.updatedClient.id;
        numberMessages = this.$store.state.messagesPM.filter(function(select_item) {
            return select_item.id === clientId;
        });
      }
      return numberMessages.length;
    },
    
    loadApplications () {
        return this.$store.getters.loadApplications;
    },

    getSourceName () {
      let sourceId = this.updatedClient.source_id;
      if (sourceId === null) return null;
      const source = this.$store.state.itemsSources.filter(c => c.id === sourceId)[0];
      return source ? source.name : null;
    },

    getSalesContactName () {
      let salesContactId = this.updatedClient.salesContact;
      if (salesContactId === null) return null;
      const contact = this.$store.state.contacts.filter(c => c.id === salesContactId)[0];
      return contact ? contact.name : null;
    },

    getNationalityName () {
      let nationalityId = this.updatedClient.nationality_id;
      if (nationalityId === null) return null;
      const nationality = this.$store.state.itemsNationality.filter(c => c.id === nationalityId)[0];
      return nationality ? nationality.nationality : null;
    },

    getPickUpTime () {
      return this.updatedClient.pickup_time?.slice(0, 5) || ''
    },

    hasOnlyEnglishCourses() {
      return (
        this.services.length > 0 &&
        this.services.every(service => `${service.type_id}` === '8')
      )
    },

  },

  watch: {

    currentClient(newValue, oldValue) {
      console.log(newValue, oldValue);
      if (newValue) {
        this.$store.dispatch('setLoadingApp', 1)
        this.initialize(newValue);
      }
    },

    loadApplications: async function () {
      console.log('loadApplications #1');
      if (this.$store.getters.loadApplications) {
        // console.log('loadApplications #2', this.$store.getters.loadApplications);
        this.getServicesClientId();
        this.getApplicationsClientId();
      }
      this.$store.dispatch('loadApplications', false);
    },


  },

  beforeCreate () {
    this.$store.dispatch('setLoadingApp', 1)
  },

  created () {
    dayjs.locale("en");
    this.initialize(null);
  },
  methods: {
    
    async initialize(clientId) {
      console.log('initialize', this.$route.params);
      console.log('initialize ###', this.$store.state.itemsSources)
      // this.tab = 1;
      this.$store.dispatch('setLoadingApp', 1);
      this.initializing = true;
      if (clientId === null && this.$route.params.id) {
        clientId = this.$route.params.id;
      }
      let application = null;
      let appId = null;
      if (clientId === null && this.$route.params.appId) {
        appId = this.$route.params.appId;
        // console.log('initialize #1');
        // open application
        application = await this.$store.dispatch('getApplicationId', appId);
        if (application) {
          // console.log('initialize #2', application);
          if (application.payerClient !== null) {
            // console.log('initialize #3', application.payerClient);
            clientId = application.payerClient;
          } else {
            // console.log('initialize #4');
            let servicesInApp = await this.$store.dispatch('getServicesAppId', appId)
            if (servicesInApp.length > 0) {
              clientId = servicesInApp[0].client_id;
            }
          }
        }
      }
      let breadcrumb = JSON.parse(JSON.stringify(this.$store.state.breadcrumbs));
      let previousView =  this.$store.state.breadcrumbs[this.$store.state.breadcrumbs.length - 1];
      if (clientId !== null) {
        if (previousView === 'Invoice' || previousView === 'Application') {
          this.tab = 1;
          breadcrumb.pop();
        } else if (previousView !== 'Client') {
          breadcrumb.push('Client');
        }
        await this.$store.dispatch('breadcrumbs', breadcrumb);
      } else {
        this.$router.push({ name: 'Leads' })
      }
      // console.log('initialize #5', clientId);
      this.updatedClient.id = clientId;

      // var date = new Date();
      // let start = date.getTime();
      // console.log('***1 initialize');

      await Promise.all([this.getClientDataAll(), this.$store.dispatch('getUploads', this.updatedClient.id), this.$store.dispatch('getProjectPlacements'), this.tourSelect = await this.$store.dispatch('getTours'), this.securityDeposits = await this.$store.dispatch('getSecurityDeposits', this.updatedClient.id)]).then(() => {
        this.updatedClient.includeHandbook = false;
        this.nowDate = this.formattedDate(new Date(), 'date');
        
        if (this.updatedClient.onlyEnglishCourses === 1 || this.updatedClient.onlyEnglishCourses) {
          this.school_welcome_email = 'english';
        } else {
          this.school_welcome_email = 'spanish';
        }

        this.tourSelect.sort(this.dynamicSort('name'));
        if (appId !== null) {
          application = this.applications.filter(function(select_item) {
            return select_item.id === appId;
          })
          this.displayApplication(application[0]);
        }
      });

      this.initializing = false;
      this.$store.dispatch('setLoadingApp', 0);

      // date = new Date();
      // let end = date.getTime();
      // const totalTime = ((end-start)/1000);
      // console.log('***2', totalTime);

      if (this.$route.params.resourceId) {
        // find service
        let resourceId = this.$route.params.resourceId;
        let resource = this.resources.filter(function(select_item) {
          return select_item.id === resourceId;
        })[0];
        this.editResource(resource)
        // this.scrollTo('scroll-id-' + resource.service_id);
      }
      this.$store.dispatch('saveDataForReport', );
    },

    async getApplicationsClientId ()  {
      console.log('getApplicationsClientId', this.updatedClient.id);
      this.applications = await this.$store.dispatch('getApplicationsClientId', this.updatedClient.id);
      this.applications.sort(this.dynamicSort('-id'));
      console.log('getApplicationsClientId #1', this.applications);
    },

    async getServicesClientId ()  {
      // console.log('getServicesClientId');
      this.services = await this.$store.dispatch('getServicesClientId', this.updatedClient.id);
      this.services.sort(this.dynamicSort('start'));
    },

    async getClientDataAll() {

      // console.log('getClientDataAll');
      var date = new Date();
      let start = date.getTime();
      console.log('getClientDataAll ***1 initialize');

      await Promise.all([this.resources = await this.$store.dispatch('getResourcesClientId', this.updatedClient.id), this.client = await this.$store.dispatch('getClientId', this.updatedClient.id), this.$store.dispatch('getRadioGroupsClient', this.updatedClient.id), this.$store.dispatch('getRadioOptionsClient', this.updatedClient.id), this.$store.dispatch('getOptionsClient', this.updatedClient.id), this.getServicesClientId(), this.getApplicationsClientId()]).then(() => {
        // console.log('getClientDataAll #1', this.updatedClient.id, this.client);
        this.updatedClient = JSON.parse(JSON.stringify(this.client));
        this.updatedOptions = JSON.parse(JSON.stringify(this.$store.state.options));
        this.updatedRadioGroups = JSON.parse(JSON.stringify(this.$store.state.radioGroups));
        this.updatedRadioOptions = JSON.parse(JSON.stringify(this.$store.state.radioOptions));
        this.prepareResources();
      });

      date = new Date();
      let end = date.getTime();
      const totalTime = ((end-start)/1000);
      console.log('getClientDataAll ***2', totalTime);
      this.$store.dispatch('setLoadingApp', 0);

    },

prepareResources() {

  for (let i = 0; i < this.resources.length; i++) {

    let typeId = this.resources[i].type_id;
    this.resources[i].typeName = this.$store.state.types.filter(function(select_item) {
      return select_item.id === typeId;
    })[0].text;

  }

},

async saveClient (param) {
      this.savingClient = true;
      // console.log('saveClient', param);
      this.dialogEditClientBasic = false;
      this.$store.dispatch('setLoadingApp', 1);
      if (param === 'info') {
        if(this.$refs.formClient.validate()) {
          this.updatedClient = Object.assign({}, this.editClient)
        } else {
          return;
        }
      }
      this.$store.dispatch('setLoadingApp', 1);
      this.errorMessageEmail = '';
      this.errorMessageNames = '';
      this.updatedClient.last_changed_by = this.$store.state.uid;
      let payload = {
          client: this.updatedClient,
          applications: null,
          services: null,
          radioGroups: null,
          radioOptions: null,
          options: null,
          resources: null,
      };
      // console.log('saveClient', payload);
      let result = await this.$store.dispatch('insertUpdateMainItems', payload);

      if (result) {
        result = result.data;
        // console.log('saveClient #1', result);
        await this.updateAllItemsPresent(result);
      }

      this.$store.dispatch('setLoadingApp', 0);
      this.savingClient = false;
},

selectFile(file, type) {
  if (file) {
    console.log('selectFile', file.name)
    if (type === 'cv') {
      this.selectFilePassport = true;
      this.selectFileOther = true;
    } else if (type === 'passport') {
      this.selectFileCV = true;
      this.selectFileOther = true;
    } else {
      this.selectFileCV = true;
      this.selectFilePassport = true;
    }
    this.currentFile = file;
    this.$store.dispatch('setFileName', file.name);
    this.uploadFile(type);
  } else {
    this.selectFileCV = false;
    this.selectFilePassport = false;
    this.selectFileOther = false;
  }
},

    async onDrop(e, type) {
      this.dragover = false;
      if (e.dataTransfer.files.length > 1) {
        this.$store.dispatch('errorMessage', 'Only one file can be uploaded at a time..');
      } else {
        console.log(e.dataTransfer.files[0].type);
        if (type === 'cv') {
          if (e.dataTransfer.files[0].type === 'application/pdf' || e.dataTransfer.files[0].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') { 
            this.currentFile = e.dataTransfer.files[0];
            await this.$store.dispatch('setFileName', this.currentFile.name);
            this.uploadFile(type);
          } else {
            this.$store.dispatch('errorMessage', 'Please add a pdf or word document');
          }
        } else if (type === 'passport') {
          if (e.dataTransfer.files[0].type === 'application/pdf' || e.dataTransfer.files[0].type === 'image/jpeg' || e.dataTransfer.files[0].type === 'image/png') { 
            this.currentFile = e.dataTransfer.files[0];
            await this.$store.dispatch('setFileName', this.currentFile.name);
            this.uploadFile(type);
          } else {
            this.$store.dispatch('errorMessage', 'Please add a pdf, jpeg or png file');
          }
        } else {
          if (e.dataTransfer.files[0].type === 'application/pdf' || e.dataTransfer.files[0].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.dataTransfer.files[0].type === 'image/jpeg' || e.dataTransfer.files[0].type === 'image/png') { 
            this.currentFile = e.dataTransfer.files[0];
            await this.$store.dispatch('setFileName', this.currentFile.name);
            this.uploadFile(type);
          } else {
            this.$store.dispatch('errorMessage', 'Please add a pdf, jpeg, png or word document');
          }
        }
      }
        
    },
    
    uploadFile(type) {
      // Capture the selected file before starting the asynchronous read.
      const file = this.currentFile;

      if (type === 'other') {
        type = null;
      }

      if (!file) {
        console.error('uploadFile: No file selected.');
        return;
      }

      const reader = new FileReader();

      reader.onload = async () => {
        try {
          const dataUrl = reader.result;

          if (typeof dataUrl !== 'string' || !dataUrl.includes(',')) {
            throw new Error('Could not read the selected file.');
          }

          const base64 = dataUrl.split(',')[1];

          const payload = {
            id: Date.now(),
            client_id: this.updatedClient.id,
            type,
            name: file.name,
            mime_type: file.type || 'application/octet-stream',
            file_size: file.size,
            file: base64,
            encoding: 'base64',
          };

          const result = await this.$store.dispatch('addUpload', payload);

          console.log('Upload successful:', result);

          if (type === null) {
            this.fileOther = null;
          }

          this.selectFileCV = false;
          this.selectFilePassport = false;
          this.selectFileOther = false;

          // await this.updateAllItemsPresent(result);
          this.$store.dispatch('getUploads', this.updatedClient.id);

        } catch (error) {
          console.error('Upload failed:', error);
        } finally {
          this.$store.dispatch('showProgressBar', false);
        }
      };

      reader.onerror = () => {
        console.error('Failed to read file:', reader.error);
        this.$store.dispatch('showProgressBar', false);
      };

      reader.readAsDataURL(file);

      // Safe to clear the component property because `file` is a local reference.
      this.currentFile = undefined;
      this.file = null;
    },

    downloadFile (payload) {
      this.$store.dispatch('downloadFile', payload);
    },

    async deleteFile (fileId) {
      const payload = {
        fileId: fileId,
        clientId: this.updatedClient.id,
      }
      let results = await this.$store.dispatch('deleteFile', payload);
      this.updateAllItemsPresent(results);
      this.$store.dispatch('getUploads', this.updatedClient.id);
    },


    async syncUploadPM (uploadId) {
      if (this.$store.state.alertVPS === 0) {
        await this.$store.dispatch('transferUploadPM', uploadId);
        this.syncButtonPassport = false;
        this.syncButtonCV = false;
      }
    },

    getUploadInfoType (type) {
      if (this.uploadInfos) {
        if (type === 'other') {
          return this.uploadInfos.filter(function(select_item) {
            return select_item.type === null;
          })
        } else {
          return this.uploadInfos.filter(function(select_item) {
            return select_item.type === type;
          })
        }
      }
    },

    cancel () {
        this.$router.go(-1);
    },

    async synchroniseClientPM () {
      if (this.$store.state.alertVPS === 0) {
        // get applications PM syncPM true
        let appsSyncPM = await this.$store.dispatch('getApplicationsPM', this.updatedClient.email)
        for (let i = 0; i < appsSyncPM.length; i++) {
          let stupidthing = appsSyncPM[i].id;
          let idAppDel = this.applications.filter(function(select_item) {
            return select_item.id === stupidthing;
          })
          if (idAppDel.length === 1) {
            if (idAppDel[0].syncPM === false || (idAppDel[0].payerClient === null && idAppDel[0].payerAgency === null)) {
              // console.log('synchroniseClientPM #1',idAppDel[0].syncPM)
              this.$store.dispatch('deleteApplicationPM', stupidthing)
            }
          } else if (appsSyncPM[i].appNew === 0) {
            // console.log('synchroniseClientPM #2')
            this.$store.dispatch('deleteApplicationPM', stupidthing)
          }
        }
        // get services PM syncPM for deletion
        await this.$store.dispatch('getServicesPM', this.updatedClient.id).then((result) => {
          let i;
          for (i = 0; i < result.length; i++) {
            let stupidthing = result[i].id;
            let delServicesSyncPM = this.services.filter(function(select_item) {
              return select_item.id === stupidthing;
            })
            if (delServicesSyncPM.length === 0) {
              this.$store.dispatch('deleteServicePM', stupidthing)
            } else {
              // look if app is sync and remove if not
              if (delServicesSyncPM[0].application_id !== result[i].application_id) {
                this.$store.dispatch('deleteServicePM', stupidthing)
              }
            }
          }
        })

        if (this.updatedClient.email !== null) {
          // await this.$store.dispatch('insertLeadPM', this.updatedClient)
          let appsSyncPM = this.applications.filter(function(select_item) {
            return select_item.syncPM === true && (select_item.payerClient !== null || select_item.payerAgency !== null);
          })
          if (appsSyncPM.length > 0) {
            let stupidthing1 = this.updatedClient.id;
            let uploadsSyncPM = this.uploadInfos.filter(function(select_item) {
              return select_item.client_id === stupidthing1 && (select_item.type === 'cv' || select_item.type === 'passport');
            })
            let i;
            for (i = 0; i < uploadsSyncPM.length; i++) {
              this.syncUploadPM(uploadsSyncPM[i].id)
            }
            for (i = 0; i < appsSyncPM.length; i++) {
              let stupidthing2 = appsSyncPM[i].id;
              appsSyncPM[i].email = this.updatedClient.email;
              // console.log('synchroniseClientPM #3', appsSyncPM[i])
              await this.$store.dispatch('insertApplicationPM', appsSyncPM[i])
              let servicesSyncPM = this.services.filter(function(select_item) {
                  return select_item.application_id === stupidthing2;
              })
              let j;
              for (j = 0; j < servicesSyncPM.length; j++) {
                let stupidthing3 = servicesSyncPM[j].id;
                servicesSyncPM[j].statusServiceId = servicesSyncPM[j].autoStatus;
                await this.$store.dispatch('insertServicePM', servicesSyncPM[j]);
                await this.$store.dispatch('insertService', servicesSyncPM[j]);
                await this.getApplicationsClientId(this.updatedClient.id);
                await this.getServicesClientId();
                let radioGroupsSyncPM = this.$store.state.radioGroups.filter(function(select_item) {
                    return select_item.services_id === stupidthing3;
                })
                let k;
                for (k = 0; k < radioGroupsSyncPM.length; k++) {
                  this.$store.dispatch('insertRadioGroupPM', radioGroupsSyncPM[k])
                }
                let radioOptionsSyncPM = this.$store.state.radioOptions.filter(function(select_item) {
                    return select_item.services_id === stupidthing3;
                })
                for (k = 0; k < radioOptionsSyncPM.length; k++) {
                  this.$store.dispatch('addRadioOptionPM', radioOptionsSyncPM[k]);
                }
                let optionsSyncPM = this.$store.state.options.filter(function(select_item) {
                    return select_item.services_id === stupidthing3;
                })
                for (k = 0; k < optionsSyncPM.length; k++) {
                  this.$store.dispatch('insertOptionPM', optionsSyncPM[k])
                }
              }
            }
          }
        }
      }
    },

    async deleteClient () {

      this.confirmDeleteClientDialog = false;
      for (let i = 0; i < this.applications.length; i++) {
        if (this.applications[i].amountOfClients === 1) {
          this.$store.dispatch('deleteApplication', this.applications[i].id);
          this.$store.dispatch('deleteApplicationPM', this.applications[i].id);
        }
      }
      this.$store.dispatch('deleteClient', this.updatedClient.id);
      this.$store.dispatch('deleteLeadPM', this.updatedClient.id);
      this.$store.dispatch('checkWithPM');
      this.$router.push({ name: 'Leads' });
      
    },
    
    async create_select_items (type_id) {
      await this.$store.dispatch('getAvailableServices');
      this.dialogSelectService = true;
      if (type_id !== null) {
        if (type_id === 'agency') {
          let tmp = this.client.agency_id;
          this.select_items = this.$store.state.available_services.filter((select_item) => {
            return select_item.agency === tmp;
          });
        } else {
          if (type_id === 7) {
            this.select_items = this.$store.state.available_services.filter((select_item) => {
                return select_item.promo_text;
              }
            );
            return;
          }
          this.select_items = this.$store.state.available_services.filter((select_item) => {
            return select_item.type_id === type_id && select_item.agency === null;
          });
        }
      }
      return;
    },

    async prepSelectServiceMove(servId) {
      this.$store.dispatch('setLoadingApp', 1);
      // console.log('prepSelectServiceMove', servId);
      this.applicationsNotStarted = await this.$store.dispatch('getApplicationsNotStarted');
      let posService = this.services.map(function(e) { return e.id; }).indexOf(servId);
      this.applicationsSelect = [];
      let appId = this.services[posService].application_id
      // console.log('prepSelectServiceMove #1', this.applicationsNotStarted, posService);
      for (let index = 0; index < this.applicationsNotStarted.length; index++) {
        if (this.services[posService].application_id !== this.applicationsNotStarted[index].id && !this.applicationsNotStarted[index].frozen) {
          if (this.services.map(function(e) { return e.application_id; }).indexOf(this.applicationsNotStarted[index].id) > -1) {
            this.applicationsNotStarted[index].group = 'own';
          } else {
            this.applicationsNotStarted[index].group = 'other';
          }
          if (this.applicationsNotStarted[index].payerClient) {
            // console.log('prepSelectServiceMove #2');
            this.applicationsNotStarted[index].payer = this.applicationsNotStarted[index].payerClientName;
            this.applicationsSelect.push(this.applicationsNotStarted[index]);
            continue;
          } else {
            // console.log('prepSelectServiceMove #4');
            this.applicationsNotStarted[index].payer = this.applicationsNotStarted[index].payerAgencyName;
            this.applicationsSelect.push(this.applicationsNotStarted[index]);
            continue;
          }
        }
      }
      this.applicationsSelect.sort(this.dynamicSort('group'));
      let service = this.services.filter(function(select_item) {
        return select_item.id === servId;
      })[0];
      this.serviceToMove = service;
      let application = this.applications.filter(function(select_item) {
        return select_item.id === appId;
      })[0];
      let amountOfClients = application.amountOfClients;
      this.onlyServiceInApp = this.services.filter(function(select_item) {
        return select_item.application_id === appId;
      }).length === 1 && amountOfClients === 1;
      this.$store.dispatch('setLoadingApp', 0);
      this.selectApplicationDialog = true;
    },

    async prepMoveService (event) {
      console.log('prepMoveService', event, event.id);
      this.selectApplicationDialog = false;
      let service = this.serviceToMove;
      let appIdNew, appIdOld = null;
      let servicesInAppOld = [];
      if (event.id) {
        // existing app
        appIdNew = event.id;
        appIdOld = service.application_id;
        servicesInAppOld = this.services.filter(function(select_item) {
          return select_item.application_id === appIdOld;
        })
        if (appIdNew === appIdOld) {
          this.$store.dispatch('errorMessage', 'The service exists already in that application');
          this.serviceToMove = null;
          return;
        }
      }
      let appOld = this.applications.filter(function(select_item) {
        return select_item.id === appIdOld;
      })[0];
      this.appIdNew = appIdNew;
      console.log('prepMoveService #1', appIdNew, appOld, servicesInAppOld);
      if (servicesInAppOld.length === 1 && appOld.amountOfClients === 1) {
        console.log('prepMoveService #2', appIdOld);
        this.appIdToDelete = appIdOld;
        this.confirmMoveServiceDialog = true;
      } else {
        this.appIdToDelete = null;
        this.moveServiceNow ();
      }
    },

    async moveServiceNow() {
      this.$store.dispatch('setLoadingApp', 1);
      let posApp = null;
      let service = this.serviceToMove;
      this.serviceToMove = null;
      console.log('moveServiceNow', service);
      let posService = this.services.map(function(e) { return e.id; }).indexOf(service.id);
      this.confirmMoveServiceDialog = false;
      let appIdNew = this.appIdNew;
      this.appIdNew = null;
      let appIdOld = null;
      if (this.services[posService].application_id && this.services[posService].application_id !== null) {
        appIdOld = this.services[posService].application_id;
      }
      service.application_id = appIdNew;
      this.services[posService] = service;
      let payload = {
        client: null,
        applications: null,
        services: [],
        radioGroups: null,
        radioOptions: null,
        options: null,
        resources: null,
      };
      payload.services.push(service);
      await this.$store.dispatch('insertUpdateMainItems', payload);
      // let response = await this.$store.dispatch('insertService', service);
      // this.$store.dispatch('successMessage', 'The service has been moved succesfully');
      if (this.appIdToDelete !== null) {
        this.deleteApplication();
      } else {
        // change app title old
        if (appIdOld !== null) {
          let posAppOld = this.applications.map(function(e) { return e.id; }).indexOf(appIdOld);
          this.applications[posAppOld].amountOfClients -= 1;
          // await this.changeAppTitle(appIdOld);
          payload = {
            client: null,
            applications: [],
            services: null,
            radioGroups: null,
            radioOptions: null,
            options: null,
            resources: null,
          };
          payload.applications.push(this.applications[posAppOld]);
          await this.$store.dispatch('insertUpdateMainItems', payload);
        }
      }
      await this.getApplicationsClientId(this.updatedClient.id);
      // change app title new
      // await this.changeAppTitle(appIdNew);
      posApp = this.applications.map(function(e) { return e.id; }).indexOf(appIdNew);
      payload = {
        client: null,
        applications: [],
        services: null,
        radioGroups: null,
        radioOptions: null,
        options: null,
        resources: null,
      };
      payload.applications.push(this.applications[posApp]);
      await this.$store.dispatch('insertUpdateMainItems', payload);
      let result = await this.$store.dispatch('successMessage', 'The service has been moved succesfully');
      if (result) {
        result = result.data;
        console.log('saveService #2', result);
        await this.updateAllItemsPresent(result);
      }
      this.$store.dispatch('setLoadingApp', 0);
      // this.getApplicationsClientId(this.updatedClient.id);
      // this.getServicesClientId();
    },

    async changeAppTitle(appId) {
      console.log('changeAppTitle', appId);
      let pos = null;
      pos = this.applications.map(function(e) { return e.id; }).indexOf(appId);
      console.log('changeAppTitle #1');
      if (pos > -1) {
        if (this.applications[pos].autoAppTitle || this.applications[pos].autoAppTitle === 1) {
        this.applications[pos].appTitle = await this.createAppTitle(this.applications[pos], null);
        console.log('changeAppTitle #2', this.applications[pos].appTitle);
        }
      } else {
        this.applications[pos].appTitle = "";
      }
      return;
    },

    async deleteService() {
      console.log('deleteService', this.serviceIdToDelete);

      this.$store.dispatch('setLoadingApp', 1);
      this.confirmDeleteServiceDialog = false;

      const serviceId = this.serviceIdToDelete;
      const message = await this.checkServiceBeforeDeleteOrUnapply(serviceId);

      if (message !== 'ok') {
        this.$store.dispatch('errorMessage', message);
        this.serviceIdToDelete = null;
        this.$store.dispatch('setLoadingApp', 0);
        return;
      }

      // Find service
      const service = this.services.find(s => s.id === serviceId);
      if (!service) {
        this.$store.dispatch('setLoadingApp', 0);
        return;
      }

      const appId = service.application_id;

      // Remove locally
      this.services = this.services.filter(s => s.id !== serviceId);

      // Delete backend
      await this.$store.dispatch('deleteService', serviceId);

      // Check if application is now empty
      const isAppEmpty = !this.services.some(s => s.application_id === appId);

      if (isAppEmpty) {
        this.appIdToDelete = appId;
        await this.deleteApplication();
      }

      // Trigger recalculation
      await this.$store.dispatch('insertUpdateMainItems', {
        client: this.updatedClient,
        applications: null,
        services: null,
        radioGroups: null,
        radioOptions: null,
        options: null,
        resources: null,
      });

      await this.getApplicationsClientId(this.updatedClient.id);
      await this.getServicesClientId();

      this.$store.dispatch('successMessage', 'Service successfully removed');

      this.serviceIdToDelete = null;
      this.$store.dispatch('setLoadingApp', 0);
    },

    async deleteResource () {
      this.confirmDeleteResourceDialog = false;
      let message = await this.checkResourceBeforeDelete(this.resourceIdToDelete);
      if (message === 'ok') {
        this.resources.splice(this.resources.map(function(e) { return e.id; }).indexOf(this.resourceIdToDelete), 1);
        this.$store.dispatch('deleteResource', this.resourceIdToDelete);
        // this.getClientDataAll();
        this.$store.dispatch('successMessage', 'Resource successfully removed');
      } else {
        this.$store.dispatch('errorMessage', message);
      }
    },

    checkApplicationBeforeDelete(appId) {
      let message = '';
      if (appId) {
        // check if application has payments
        let application = this.applications.filter(function(select_item) {
          return select_item.id === appId;
        })[0];
        // console.log('checkApplicationBeforeDelete', application.amountPaidApplication);
        if (application.amountPaidApplication && Math.abs(application.amountPaidApplication > 0)) {
          message = "The application has already payments";
          return message;
        }
        let servicesInApp = this.services.filter(function(select_item) {
          return select_item.application_id === appId;
        })
        if (servicesInApp) {
          for (let index = 0; index < servicesInApp.length; index++) {
            let serviceId = servicesInApp[index].id;
            let resourcesInThisService = this.resources.filter(function(select_item) {
              return select_item.service_id === serviceId;
            })
            for (let index = 0; index < resourcesInThisService.length; index++) {
              message = this.checkResourceBeforeDelete(resourcesInThisService[index].id);
              if (message !== 'ok') {
                return message;
              }
            }
          }
        }
      }
      return 'ok';
    },

    checkAllApplicationsBeforeDelete() {
      for (let index = 0; index < this.applications.length; index++) {
        let message = this.checkApplicationBeforeDelete(this.applications[index].id);
        if (message !== 'ok') {
          return message;
        }
      }
      return 'ok';
    },

    checkServiceBeforeDeleteOrUnapply(serviceId) {
      // 1. Check resources
      const resourcesInService = this.resources.filter(r => r.service_id === serviceId);

      for (const resource of resourcesInService) {
        const result = this.checkResourceBeforeDelete(resource.id);
        if (result !== 'ok') return result;
      }

      // 2. Find service
      const service = this.services.find(s => s.id === serviceId);
      if (!service || service.application_id === null) return 'ok';

      const appId = service.application_id;

      // 3. Check application removable
      const appCheck = this.checkApplicationIfRemovable(appId);
      if (appCheck !== 'ok') return appCheck;

      // 4. Check if last service in application
      // const servicesInApp = this.services.filter(s => s.application_id === appId);

      // if (servicesInApp.length === 1) {
      //   return "Only one Service for this Application";
      // }

      return 'ok';
    },

    checkApplicationIfRemovable(appId) {
      if (!appId) return 'ok';

      const application = this.applications.find(a => a.id === appId);
      if (!application) return 'ok';

      const servicesInApp = this.services.filter(s => s.application_id === appId);

      if (
        servicesInApp.length === 1 &&
        application.amountPaidApplication !== null &&
        application.amountPaidApplication > 0
      ) {
        return "A payment already exist for the Application";
      }

      return 'ok';
    },

    checkResourceBeforeDelete(resourceId) {
      let posRes = this.resources.map(function(e) { return e.id; }).indexOf(resourceId);
      if (this.resources[posRes].type_id === 3 || this.resources[posRes].type_id === 8) {
        if (this.resources[posRes].minutes_planned > 0) {
          return 'Classes already planned';
        }
      }
      if ((this.resources[posRes].type_id === 1 || this.resources[posRes].type_id === 2) && this.resources[posRes].placement_id > 0) {
        return 'Project already planned';
      }
      if (this.resources[posRes].type_id === 4 && this.resources[posRes].room_id > 0) {
        return 'Accommodation already planned';
      }
      if (this.resources[posRes].type_id === 5 && this.resources[posRes].tour_placement_id > 0) {
        return 'Tour already planned';
      }
      return 'ok';
    },    
    
    getImage(id) {
      const images = this.$store.state.available_images;

      if (!images || !id) return null;

      const item = images.find(select_item => select_item.id === id);

      if (!item || !item.image) return null;

      let bytes;

      if (typeof item.image === 'string') {
        // Base64-encoded JPEG
        bytes = Buffer.from(item.image, 'base64');
      } else {
        // Existing Buffer or byte array
        bytes = Buffer.from(item.image);
      }

      return `data:image/jpeg;base64,${bytes.toString('base64')}`;
    },

    getStartDays(value) {
      const date = dayjs(value);
      const day = date.format("dddd").toLowerCase();
      return this.startDays.includes(day);
    },

    getEndDays(value) {
      const date = dayjs(value);
      const day = date.format("dddd").toLowerCase();
      return this.endDays.includes(day);
    },

    changeAllowedStartDays(service_number) {
      console.log('changeAllowedStartDays', service_number);
      if (this.$store.state.available_services.filter(function(select_item) {
          return select_item.service_number === service_number;
        }).length > 0) {
        this.startDays = this.$store.state.available_services.filter(function(select_item) {
          return select_item.service_number === service_number;
        })[0].allowedStartDays
      } else {
        this.startDays = 'sunday, saturday, monday, tuesday, wednesday, thursday, friday'
      }
    },

    changeAllowedEndDays(service_number) {
      console.log('changeAllowedEndDays', service_number);
      if (this.$store.state.available_services.filter(function(select_item) {
          return select_item.service_number === service_number;
        }).length > 0) {
        this.endDays = this.$store.state.available_services.filter(function(select_item) {
          return select_item.service_number === service_number;
        })[0].allowedEndDays
      } else {
        this.endDays = 'sunday, saturday, monday, tuesday, wednesday, thursday, friday'
      }
    },

    clearStartDate() {
      this.updatedService.start = null;
      this.updatedService.end = null;
      if (this.updatedService.duration_type !== "fixed") {
        this.updatedService.duration = this.updatedService.min_duration;
      }
      this.updatedServiceStart = null;
    },

    clearEndDate() {
      this.updatedService.end = null;
      if (this.updatedService.min_duration !== null) {
        this.updatedService.duration = this.updatedService.min_duration;
      } else {
        this.updatedService.duration = null;
      }
      this.updatedResourceEnd = null;
    },

    disabledEndDate (id) {
      // console.log('disabledEndDate', id, this.updatedService.start, this.updatedService.duration_type, this.updatedService.duration_text, this.updatedService.service_number);
      if (id) {
        if (!this.updatedService.service_number) {
          return true;
        }
        if (this.updatedService.duration_type === "fixed" && this.updatedService.duration_text !== "hour(s)" && this.updatedService.duration_text !== "afternoon" && this.updatedService.duration_text !== "morning" && this.updatedService.duration_text !== "month(s)") {
          return true;
        }
      }
      return false;
    },

    getMinEndDate () {
      if (this.updatedService.start) {
        if (this.updatedServicemin_duration && this.updatedService.duration_type === "businessWeeks") {
          return this.addbusinessWeeks(this.updatedService.start, (this.updatedServicemin_duration * 5) - 1);
        }
        if (this.updatedServicemin_duration && this.updatedService.duration_type === "businessDays") {
          return this.addbusinessWeeks(this.updatedService.start, (this.updatedServicemin_duration) - 1);
        }
        if (this.updatedServicemin_duration && this.updatedService.duration_type === "nights") {
          return this.addDays(this.updatedService.start, this.updatedServicemin_duration);
        }
        return this.updatedService.start;
      } else {
        return null;
      }
    },

    async calcDatesServices(action, radioGroup) {
      if (this.initializing) {
        return;
      }
      this.$store.dispatch('setLoadingApp', 1);
      console.log('calcDatesServices #1', action, radioGroup);
      var avRadioOptions;
      if (radioGroup) {
        avRadioOptions = this.$store.state.radioOptions.filter(function(item) {
          return item.radio_group_id === radioGroup.radio_group_id && item.label === radioGroup.radio_group_value && (item.duration !== null || item.min_duration !== null);
        })
        if (avRadioOptions) {
          if (avRadioOptions.length > 0) {
            if (avRadioOptions[0].duration) {
              this.updatedService.duration = avRadioOptions[0].duration;
            }
            if (avRadioOptions[0].min_duration && this.updatedService.duration < avRadioOptions[0].min_duration) {
              this.updatedService.duration = avRadioOptions[0].min_duration;
            }
          }
        }
      }
      if (this.updatedService.service_number) {
        let serviceNr = this.updatedService.service_number;
        let priceTable = null;
        if (this.updatedService.pricingMethod === "table") {
          priceTable = await this.$store.dispatch('getAvailablePriceTable', serviceNr);
          if (action === 'start' || action === 'end') {
            if (this.updatedService.start && this.updatedService.end) {
              let days = Math.ceil(this.diffDates(this.updatedService.start, this.updatedService.end));
              this.updatedService.duration = Math.ceil(days / 7);
            }
          }
          if (action === 'duration') {
            if (priceTable.length < this.updatedService.duration) {
              this.updatedService.duration = priceTable.length;
            }
            if (this.updatedService.start) {
              this.updatedService.end = this.addDays(this.updatedService.start, this.updatedService.duration * 7);
            }
          }
        }
        if(this.updatedService.duration_type === "weeks") {
          if ((action === 'duration' && this.updatedService.start) || ((action === 'start' && this.updatedService.duration))) {
            this.updatedService.end = this.addDays(this.updatedService.start, this.updatedService.duration * 7);
          }
          if (action === 'start' || action === 'end') {
            if (this.updatedService.start && this.updatedService.end) {
              let days = Math.ceil(this.diffDates(this.updatedService.start, this.updatedService.end));
              let weeks = Math.ceil(days / 7);
              if (weeks < this.updatedServicemin_duration) {
                this.updatedService.end = this.addDays(this.updatedService.start, this.updatedServicemin_duration * 7);
              } else {
                this.updatedService.duration = weeks;
              }
            }
          }
        }
        if(this.updatedService.duration_type === "businessWeeks") {
          if ((action === 'duration' && this.updatedService.start) || ((action === 'start' && this.updatedService.duration))) {
            this.updatedService.end = this.addbusinessWeeks(this.updatedService.start, ((this.updatedService.duration * 5)-1));
          }
          if (action === 'start' || action === 'end') {
            if (this.updatedService.start && this.updatedService.end) {
              let weeks = ((dayjs(this.updatedService.end).businessDiff(dayjs(this.updatedService.start))+1)/5);
              if (weeks < this.updatedServicemin_duration) {
                this.updatedService.end = this.addbusinessWeeks(this.updatedService.start, ((this.updatedService.duration * 5)-1));
              } else {
                this.updatedService.duration = Math.ceil(weeks);
              }
            }
          }
        }
        if(this.updatedService.duration_type === "businessDays") {
          if (action === 'start' || action === 'end') {
            if (this.updatedService.start && this.updatedService.end) {
              let days = ((dayjs(this.updatedService.end).businessDiff(dayjs(this.updatedService.start))+1));
              if (days < this.updatedServicemin_duration && action === 'start') {
                this.updatedService.duration = this.updatedServicemin_duration;
                this.updatedService.end = null;
              } else {
                this.updatedService.duration = days;
              }
            }
          }
        }
        if(this.updatedService.duration_type === "nights") {
          if (action === 'start' || action === 'end') {
            if (this.updatedService.start && this.updatedService.end) {
              let nights = Math.ceil(this.diffDates(this.updatedService.start, this.updatedService.end));
              if (nights < this.updatedService.duration && action === 'start') {
                this.updatedService.duration = this.updatedServicemin_duration;
                this.updatedService.end = null;
              } else {
                this.updatedService.duration = nights;
              }
            } else {
                this.updatedService.duration = this.updatedServicemin_duration;
            }
          }
        }
        if(this.updatedService.duration_type === "fixed") {
          if (action === 'start' && this.updatedService.start) {
            if (this.updatedService.duration_text === 'week(s)') {
              this.updatedService.end = this.addWeeks(this.updatedService.start, this.updatedService.duration);
            }
            else if (this.updatedService.duration_text === 'morning' || this.updatedService.duration_text === 'afternoon') {
              this.updatedService.end = this.updatedService.start;
            }
            else {
              this.updatedService.end = this.addDays(this.updatedService.start, this.updatedService.duration - 1);
            }
          }
        }
        console.log('calcDatesServices #end');
        this.updatedServiceStart = this.updatedService.start;
        this.updatedServiceEnd = this.updatedService.end;
        this.updatedService.servicePrice = await this.calcPriceService(this.updatedService);
        this.$store.dispatch('setLoadingApp', 0);
      }
    },

    async calcDatesResource(action) {
      console.log('calcDatesResource action = ' , action)
      if(this.updatedResource.type_id === 1 || this.updatedResource.type_id === 2) {
        if (this.updatedResource.start && ((action === 'duration' && this.updatedResource.start) || ((action === 'start' && this.updatedResource.duration)))) {
          console.log('calcDatesResource test1')
          this.updatedResource.end = this.addbusinessWeeks(this.updatedResource.start, ((this.updatedResource.businessWeeks * 5)-1));
        }
        if (action === 'start' || action === 'end') {
          if (this.updatedResource.start && this.updatedResource.end) {
            let weeks = ((dayjs(this.updatedResource.end).businessDiff(dayjs(this.updatedResource.start))+1)/5);
            if (weeks < this.updatedResource.min_duration) {
              this.updatedResource.end = this.addbusinessWeeks(this.updatedResource.start, ((this.updatedResource.duration * 5)-1));
            } else {
              this.updatedResource.duration = Math.ceil(weeks);
              this.updatedResource.businessWeeks = Math.ceil(weeks);
            }
          }
        }
      }
      if(this.updatedResource.type_id === 3 || this.updatedResource.type_id === 8) {
        console.log('calcDatesResource #1')
        if ((action === 'duration' && this.updatedResource.start) || ((action === 'start' && this.updatedResource.duration && this.updatedResource.start))) {
          console.log('calcDatesResource #2', this.updatedResource.start , this.updatedResource.duration)
          this.updatedResource.end = this.addbusinessWeeks(this.updatedResource.start, ((this.updatedResource.duration * 5)-1));
        } else if (action === 'start' || action === 'end') {
          if (this.updatedResource.start && this.updatedResource.end) {
            let weeks = ((dayjs(this.updatedResource.end).businessDiff(dayjs(this.updatedResource.start))+1)/5);
            if (weeks < this.updatedResource.min_duration) {
              this.updatedResource.end = this.addbusinessWeeks(this.updatedResource.start, ((this.updatedResource.duration * 5)-1));
            } else {
              this.updatedResource.duration = Math.ceil(weeks);
            }
          }
        }
      }
      if(this.updatedResource.type_id === 4) {
        if ((action === 'duration' && this.updatedResource.start) || ((action === 'start' && this.updatedResource.duration))) {
          this.updatedResource.end = this.addDays(this.updatedResource.start, (this.updatedResource.duration));
        }
        if (action === 'start' || action === 'end') {
          if (this.updatedResource.start && this.updatedResource.end) {
            let nights = Math.ceil(this.diffDates(this.updatedResource.start, this.updatedResource.end));
            if (nights > this.updatedResource.min_duration) {
              if (action === 'start') {
                this.updatedResource.start = this.addDays(this.updatedResource.end, (-this.updatedResource.min_duration));
              } else {
                this.updatedResource.end = this.addDays(this.updatedResource.start, (this.updatedResource.min_duration));
              }
            }
            this.updatedResource.duration = Math.ceil(this.diffDates(this.updatedResource.start, this.updatedResource.end));
          } 
        }
      }
      if(this.updatedResource.type_id === 5) {
        if (action === 'start') {
          if (this.updatedResource.duration_text === 'weeks') {
            this.updatedResource.end = this.addWeeks(this.updatedResource.start, this.updatedResource.duration);
          }
          else if (this.updatedResource.duration_text === 'morning' || this.updatedResource.duration_text === 'afternoon') {
            this.updatedResource.end = this.updatedResource.start;
          }
          else {
            this.updatedResource.end = this.addDays(this.updatedResource.start, this.updatedResource.duration);
          }
        }
      }
      this.updatedResourceStart = this.updatedResource.start;
      this.updatedResourceEnd = this.updatedResource.end;
    },

    async calcPriceService(service) {
      const serviceNr = service.service_number;

      let servicePrice = this.decUtil.toDec(0);
      let varPrice = this.decUtil.toDec(0);

      /* ---------------- OPTIONS ---------------- */
      for (const opt of this.updatedOptions) {
        if (opt.selected && opt.services_id === service.id) {
          servicePrice = servicePrice.plus(this.decUtil.toDec(opt.price));
          varPrice = varPrice.plus(this.decUtil.toDec(opt.varPrice));
        }
      }

      /* ---------------- RADIO GROUPS ---------------- */
      for (const group of this.updatedRadioGroups) {
        if (group.services_id !== service.id) continue;

        const radioOptions = this.updatedRadioOptions.filter(o =>
          o.radio_group_id === group.radio_group_id &&
          o.services_id === group.services_id
        );

        for (const opt of radioOptions) {
          if (opt.label !== group.radio_group_value) continue;

          servicePrice = servicePrice.plus(this.decUtil.toDec(opt.price));

          const optVar = this.decUtil.toDec(opt.varPrice);

          if (
            opt.discount_after < service.duration &&
            opt.discount_percentage
          ) {
            const discountAfter = this.decUtil.toDec(opt.discount_after);
            const duration = this.decUtil.toDec(service.duration);
            const discountPct = this.decUtil.toDec(opt.discount_percentage).div(100);

            const discounted =
              optVar.minus(optVar.times(discountPct));

            const blended = optVar
              .times(discountAfter)
              .plus(
                discounted.times(duration.minus(discountAfter))
              )
              .div(duration);

            varPrice = varPrice.plus(blended);
          } else {
            varPrice = varPrice.plus(optVar);
          }
        }
      }

      /* ---------------- PRICE TABLE ---------------- */
      const pricingTable = await this.$store.dispatch(
        'getAvailablePriceTable',
        serviceNr
      );

      const availableServices = await this.$store.dispatch(
        'getAvailableServicesEdit'
      );

      const avServ = availableServices.find(
        s => s.service_number === serviceNr
      );

      if (availableServices.pricingMethod === 'table') {
        const weeks = Math.min(pricingTable.length, service.duration);

        if (weeks < service.duration) {
          this.$store.dispatch(
            'warningMessage',
            `Price calculated for ${weeks} weeks`
          );
        }

        const row = pricingTable.find(r => r.weeks === weeks);
        const tablePrice = row
          ? this.decUtil.toDec(row.price)
          : this.decUtil.toDec(0);

        if (avServ) {
          servicePrice = servicePrice
            .plus(this.decUtil.toDec(service.duration).times(varPrice))
            .plus(tablePrice)
            .plus(this.decUtil.toDec(avServ.price));
        }

        return servicePrice;
      }

      /* ---------------- FALLBACK ---------------- */
      if (avServ) {
        if (avServ.price_type === 'fixed') {
          servicePrice = servicePrice.plus(this.decUtil.toDec(avServ.price));
        } else {
          servicePrice = servicePrice
            .plus(
              this.decUtil.toDec(service.duration).times(
                this.decUtil.toDec(avServ.varPrice).plus(varPrice)
              )
            )
            .plus(this.decUtil.toDec(avServ.price));
        }
      }

      return servicePrice;
    },

    getStatusResource(id) {
      if (id) {
        return this.$store.state.statusResources.filter((select_item) => {
            return select_item.id === id;
          })[0];
      } else {
        return [];
      }
    },

    async selectService (newServiceNr) {

      var dateTimer = new Date();
      let start = dateTimer.getTime();
      console.log('selectService ***1');
      
      this.$store.dispatch('setLoadingApp', 1);
      let payload = {
        client: null,
        applications: [],
        services: [],
        radioGroups: [],
        radioOptions: [],
        options: [],
        resources: [],
      };
      this.dialogSelectService = false;
      this.dialogAddType = false;
      let date = new Date();
      var idServiceAppNew = date.getTime();
      console.log('selectService', idServiceAppNew);
      let serviceNew = this.$store.state.available_services.filter(function(select_item) {
        return select_item.service_number === newServiceNr;
      })[0];
      serviceNew.id = idServiceAppNew;
      serviceNew.autoStatus = 4;
      serviceNew.client_id = this.updatedClient.id;
      serviceNew.full_name = this.updatedClient.full_name;
      serviceNew.service_number = newServiceNr;
      if (this.selectedApplicationId) {
        serviceNew.application_id = this.selectedApplicationId;
      } else {
        serviceNew.application_id = idServiceAppNew;
        await this.createNewApplication(idServiceAppNew);
      }
      this.services.push(serviceNew);
      let newPosService = this.services.map(function(e) { return e.id; }).indexOf(idServiceAppNew);
      // add local depending options
      let optionsSelected = this.$store.state.availableOptions.filter(function(item) {
        return item.available_service_number === newServiceNr;
      })
      let i;
      for (i = 0; i < optionsSelected.length; i++) {
        optionsSelected[i].services_id = idServiceAppNew;
        let optionsSelectedPush = JSON.parse(JSON.stringify(optionsSelected[i]));
        optionsSelectedPush.selected = false;
        payload.options.push(optionsSelectedPush);
        this.updatedOptions.push(optionsSelectedPush);
      }
      let radioGroupSelected = this.$store.state.availableRadioGroups.filter(function(item) {
        return item.available_service_number === newServiceNr;
      })
      date = new Date();
      let radioOptionId = date.getTime();
      let counter = 0;
      for (i = 0; i < radioGroupSelected.length; i++) {
        radioGroupSelected[i].services_id = idServiceAppNew;
        let radioGroupSelectedPush = JSON.parse(JSON.stringify(radioGroupSelected[i]));
        console.log('selectService #1', radioGroupSelectedPush);
        payload.radioGroups.push(radioGroupSelectedPush);
        this.updatedRadioGroups.push(radioGroupSelectedPush);
        // add radio options
        let radioGroupId = radioGroupSelected[i].radio_group_id;
        let radioOptionsSelected = this.$store.state.availableRadioGroupOptions.filter(function(item) {
          return item.radio_group_id === radioGroupId;
        })
        for (let index = 0; index < radioOptionsSelected.length; index++) {
          radioOptionsSelected[index].services_id = idServiceAppNew;
          radioOptionsSelected[index].id = Number(radioOptionId) + counter;
          counter++;
          let radioOptionsSelectedPush = JSON.parse(JSON.stringify(radioOptionsSelected[index]));
          console.log('selectService #2', radioOptionsSelectedPush.id);
          payload.radioOptions.push(radioOptionsSelectedPush);
          this.updatedRadioOptions.push(radioOptionsSelectedPush);
        }
      }
      // if preset add resources
      let resourcesPresets = await this.$store.dispatch('getResourcesPresetsServiceNr', this.services[newPosService].service_number);
      date = new Date();
      let resourcesFirstId = date.getTime();
      for (let index = 0; index < resourcesPresets.length; index++) {
        resourcesPresets[index].id = null;
        let typeId = resourcesPresets[index].type_id;
        resourcesPresets[index].typeName = this.$store.state.types.filter(function(select_item) {
          return select_item.id === typeId;
        })[0].text;
        resourcesPresets[index].statusResourceId = 9;
        resourcesPresets[index].service_id = idServiceAppNew;
        resourcesPresets[index].id = Number(resourcesFirstId) + index;
        let resourcesPresetsPush = JSON.parse(JSON.stringify(resourcesPresets[index]));
        if (resourcesPresetsPush.extras == null) { resourcesPresetsPush.extras = 0; }
        payload.resources.push(resourcesPresetsPush);
        this.resources.push(resourcesPresetsPush);
      }
      this.services[newPosService].servicePrice = await this.calcPriceService(this.services[newPosService]);
      payload.services.push(this.services[newPosService]);
      let posApp = this.applications.map(function(e) { return e.id; }).indexOf(serviceNew.application_id);
      let application = JSON.parse(JSON.stringify(this.applications[posApp]));
      application.appTitle = this.updatedClient.full_name + ' - ' + serviceNew.name;
      payload.applications.push(application);
      // console.log('selectService #4', application, payload);
      let result = await this.$store.dispatch('insertUpdateMainItems', payload);
      if (result) {
        result = result.data;
        // console.log('selectService #4.1', result);
      
        let posAppResult = result.applications.map(function(e) { return e.id; }).indexOf(serviceNew.application_id);
        if (posAppResult > -1) {
          this.applications[posApp] = JSON.parse(JSON.stringify(result.applications[posAppResult]));
          this.applications.sort(this.dynamicSort('-id'));
        }

        for (let index = 0; index < this.services.length; index++) {
          let posService = result.services.map(function(e) { return e.id; }).indexOf(this.services[index].id);
          if (posService > -1) {
            // console.log('selectService #4.2', result.services[posService]);
            this.services[index] = JSON.parse(JSON.stringify(result.services[posService]));
          }
        }
        
        for (let index = 0; index < this.resources.length; index++) {
          let posResource = result.resources.map(function(e) { return e.id; }).indexOf(this.resources[index].id);
          if (posResource > -1) {
            // console.log('selectService #4.3', result.resources[posResource]);
            this.resources[index] = JSON.parse(JSON.stringify(result.resources[posResource]));
          }
        }

      }
      dateTimer = new Date();
      let end = dateTimer.getTime();
      const totalTime = ((end-start)/1000);
      console.log('selectService ***2', totalTime);
      
      this.$store.dispatch('setLoadingApp', 0);
    },

    async createNewApplication(appIdnew) {
      console.log('createNewApplication');
      let newApp = {};
      newApp.id = appIdnew;
      newApp.autoAppTitle = true;
      newApp.amountPaidApplication = 0;
      newApp.frozen = false;
      newApp.pass_to_planning = this.client.pass_to_planning;
      newApp.amountOfClients = 1;
      newApp.syncPM = true;
      newApp.fixedPrice = null;
      newApp.totalPrice = null;
      newApp.depositTotal = null;
      newApp.currencyFixed = '$';
      newApp.discount = null;
      newApp.discountPercentage = null;
      newApp.currencyDiscount = '$';
      newApp.refund = null;
      newApp.currencyRefund = '$';
      newApp.exchangeRate = this.$store.state.exchangeRate;
      newApp.comments = null;
      newApp.last_changed_by = this.$store.state.uid;
      newApp.applicationNotPaid = 1;
      newApp.depositPaid = 0;
      
      if (this.client.pass_to_planning || this.client.pass_to_planning === 1) {
        let agencyId = this.client.agency_id;
        newApp.payerAgency = agencyId;
        let agency = this.$store.state.available_agencies.filter(function(select_item) {
          return select_item.id === agencyId;
        })
        if (agency && agency.length > 0) {
          newApp.payerAgencyName = agency[0].name;
        }
        newApp.payerClient = null;
        newApp.payerClientName = null;
      } else {
        newApp.payerAgency = null;
        newApp.payerAgencyName = null;
        newApp.payerClient = this.client.id;
        newApp.payerClientName = this.client.full_name;
      }

      this.applications.push(newApp);
      this.applications.sort(this.dynamicSort('-id'));
      return;
    },

    async moveServiceToNewApp() {
      console.log('moveServiceToNewApp');
      this.$store.dispatch('setLoadingApp', 1);
      this.dialogSelectService = false;
      this.dialogAddType = false;
      let service = this.serviceToMove;
      this.serviceToMove = null;
      // let appIdOld = service.application_id;
      let payload = {};
      const date = new Date();
      var idAppNew = date.getTime();
      service.application_id = idAppNew;
      await this.createNewApplication(idAppNew);
      let posAppNew = this.applications.map(function(e) { return e.id; }).indexOf(idAppNew);
      payload = {
          client: null,
          applications: [],
          services: null,
          radioGroups: null,
          radioOptions: null,
          options: null,
          resources: null,
      };
      payload.applications.push(this.applications[posAppNew]);
      await this.$store.dispatch('insertUpdateMainItems', payload);
      let posService = this.services.map(function(e) { return e.id; }).indexOf(service.id);
      this.services[posService] = service;
      payload = {
        client: null,
        application: null,
        services: [],
        radioGroups: null,
        radioOptions: null,
        options: null,
        resources: null,
      };
      payload.services.push(service);
      
      let result = await this.$store.dispatch('insertUpdateMainItems', payload);

      if (result) {
        result = result.data;
        await this.updateAllItemsPresent(result);
      }

      this.$store.dispatch('setLoadingApp', 0);
    },
    
    async deleteApplication() {
      // console.log('deleteApplication', this.appIdToDelete);
      let appId = this.appIdToDelete;
      this.appIdToDelete = null;
      this.confirmDeleteAppDialog = false;
      let pos = this.applications.map(function(e) { return e.id; }).indexOf(appId);
      this.applications.splice(pos, 1);
      // console.log('deleteApplication #1', appId);
      let result = await this.$store.dispatch('deleteApplication', appId);
      // console.log('deleteApplication #2', result);
      if (result) {
        result = result.data;
        await this.updateAllItemsPresent(result);
      }

      let servicesInApp = this.services.filter(function(item) {
        return item.application_id === appId;
      })
      for (let i = 0; i < servicesInApp.length; i++) {
        this.services.splice(this.services.map(function(e) { return e.id; }).indexOf(servicesInApp[i].id), 1);
      }
    },

    addWeeks(startDate, weeks) {
      let new_date = dayjs(startDate).add((weeks * 7), 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },

    addWeeksWorkWeek(startDate, weeks) {
      let new_date = dayjs(startDate).add(((weeks * 7) - 3), 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },

    addDays(startDate, days) {
      let new_date = dayjs(startDate).add(days, 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },

    diffDates(startDate, endDate) {
      return dayjs(endDate).diff(dayjs(startDate), 'd');
    },
    
    addbusinessWeeks(startDate, days) {
      let new_date = dayjs(startDate).businessDaysAdd(days, 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },

    addProvider(resource_type) {

      this.dialog_add_resource = false;
      let currentServiceId = this.serviceIdToResource;

      let currentService = this.services.filter(function(select_item) {
        return select_item.id === currentServiceId;
      })[0];

      let resourcesSameType = this.resources.filter(function(select_item) {
        return select_item.type_id === resource_type;
      });

      if (resourcesSameType.length === 0) {
        var number_type = 1
      } else {
        number_type = Math.max.apply(Math, resourcesSameType.map(function(o) { return o.number_type; }));
        number_type++;
      }

      let typeName = this.$store.state.types.filter(function(select_item) {
        return select_item.id === resource_type;
      })[0].text;

      let class_language = 'Spanish';
      if (resource_type === 8) {
        class_language = 'English';
      }

      let newResource = { 
        id: null, number_type: number_type, 
        service_id: currentServiceId, 
        type_id: resource_type,
        typeName: typeName,
        category_id: null, 
        project_id: null, 
        placement_id: null, 
        course_id: null, 
        class_language: class_language,
        class_location: 'School Cusco', 
        class_type: 'Normal', 
        class_group: 'Group', 
        hours: null, 
        hours_per_class: null, 
        family: 1, 
        accommodation_class: 'Private Room', 
        private_bathroom: 0, 
        start: currentService.start, 
        end: currentService.end, 
        duration: currentService.duration, 
        donation: null, 
        donation_type: null, 
        payment: null, 
        currency: null 
      };
      console.log(newResource);
      this.insertUpdateResource (newResource);
    },

    categoriesProjects (resourceType) {
      let type;
      if (resourceType === 1) {
        type = "Volunteering"
      } else {
        type = "Internship"
      }
      let selection = this.$store.state.projects.filter(function(select_item) {
        return select_item.type === type;
      });
      return selection.sort(this.dynamicSort('category'));
    },

    filterProjects (resourceType, categoryId, projectId) {
      let type;
      var selection;
      if (resourceType === 1) {
        type = "Volunteering"
      } else {
        type = "Internship"
      }
      if (projectId && !categoryId) {
        console.log(resourceType, categoryId, projectId);
        selection = this.$store.state.projects.filter(function(select_item) {
          return select_item.id === projectId && select_item.type && select_item.obsolete === null;
        })
      } else {
        if (categoryId) {
          selection = this.$store.state.projects.filter(function(select_item) {
            return select_item.category_id === categoryId && select_item.type === type && select_item.obsolete === null;
          })
        } else {
          selection = this.$store.state.projects.filter(function(select_item) {
            return select_item.type === type && select_item.obsolete === null;
          })
        }
      }
      return selection.sort(this.dynamicSort('name'));
    },

    async insertUpdateResource (resource) {
      // console.log('insertUpdateResource #1', resource);
      this.changingResource = resource.id;
      if (resource.family === '1' && resource.accommodation_class === 'Shared Bunk') {
        resource.accommodation_class = 'Private Room';
      }
      if (!resource.hours > 0) {
        resource.hours = 0;
      }
      let pos = null;
      pos = this.resources.map(function(e) { return e.id; }).indexOf(resource.id);
      if (pos === -1) {
        this.resources.push(resource);
        var date = new Date();
        resource.id = date.getTime();
      } else {
        console.log('insertUpdateResource #1a', resource);
        this.resources[pos] = resource;
      }

      resource.last_changed_by = this.$store.state.uid;
      
      let payload = {
          client: null,
          applications: null,
          services: null,
          radioGroups: null,
          radioOptions: null,
          options: null,
          resources: [],
      };
      payload.resources.push(resource);
      let result = await this.$store.dispatch('insertUpdateMainItems', payload);

      if (result) {
        result = result.data;
        console.log('insertUpdateResource #2', result);
        await this.updateAllItemsPresent(result);
      }

      // this.resources = await this.$store.dispatch('getResourcesClientId', this.updatedClient.id);
      this.changingResource = null;
    },

    async copyClient() {

      this.$store.dispatch('setLoadingApp', 1);

      const newClientId = Date.now();

      const payload = this.createPayload();

      payload.client = this.cloneClient(newClientId);

      const {
        services,
        options,
        radioGroups,
        resources
      } = this.prepareServiceData();

      await this.copyServices(
        services,
        options,
        radioGroups,
        resources,
        newClientId,
        payload
      );

      // payload.applications = this.copyApplications();

      await this.$store.dispatch('insertUpdateMainItems', payload);

      this.$route.params.id = newClientId;

      this.$store.dispatch('successMessage', 'Client successfully copied');

      this.initialize(newClientId);
    },

    createPayload() {
      return {
        client: {},
        applications: [],
        services: [],
        radioGroups: [],
        radioOptions: [],
        options: [],
        resources: []
      };
    },

    cloneClient(newClientId) {

      const client = JSON.parse(JSON.stringify(this.client));

      Object.assign(client, {
          id: newClientId,
          first_name: 'COPY OF ' + client.first_name,
          birthdate: null,
          handbookSent: null,
          first_schedule_sent: null,
          food_preference: null,
          pets_preference: null,
          spanishTestDone: null,
          initial_spanish_level: null,
          email: null,
          welcome_email: null,
          ignore_welcome_email: 0,
          ignore_security_deposit: 0,
          thank_you_email: null,
          ignore_thank_you_email: 0,
          statusFixed: 0
        });

        return client;
    },

    prepareServiceData() {
      return {
        services: JSON.parse(JSON.stringify(this.services)),
        options: JSON.parse(JSON.stringify(this.$store.state.options)),
        radioGroups: JSON.parse(JSON.stringify(this.$store.state.radioGroups)),
        resources: JSON.parse(JSON.stringify(this.resources))
      };
    },

    async copyServices(services, options, radioGroups, resources, newClientId, payload) {

      for (const service of services) {

        const oldServiceId = service.id;
        const newServiceId = Date.now() + Math.floor(Math.random() * 1000)

        service.id = newServiceId;
        service.client_id = newClientId;

        payload.services.push(service);

        this.copyOptions(options, oldServiceId, newServiceId, payload);

        await this.copyRadioGroups(radioGroups, oldServiceId, newServiceId, payload);

        this.copyResources(resources, oldServiceId, newServiceId, payload);
      }
    },

    copyOptions(options, oldServiceId, newServiceId, payload) {

      options
        .filter(o => o.services_id === oldServiceId)
        .forEach(o => {
          o.services_id = newServiceId;
          payload.options.push(o);
        });
    },

    async copyRadioGroups(radioGroups, oldServiceId, newServiceId, payload) {

      const groups = radioGroups.filter(r => r.services_id === oldServiceId);

      for (const group of groups) {

        group.services_id = newServiceId;

        payload.radioGroups.push(group);

        const radioOptions = await this.$store.dispatch(
          'getAvailableRadioGroupOptionsGroupId',
          group.radio_group_id
        );

        radioOptions.forEach(option => {
          option.services_id = newServiceId;
          payload.radioOptions.push(option);
        });
      }
    },

    copyResources(resources, oldServiceId, newServiceId, payload) {

      resources
        .filter(r => r.service_id === oldServiceId)
        .forEach(r => {

          Object.assign(r, {
            id: newServiceId,
            service_id: newServiceId,
            placement_id: null,
            course_id: null,
            room_id: null,
            tour_placement_id: null,
            info_to_client: null,
            info_to_provider: null,
            reserved: null,
            payment_info_sent: null
          });

          payload.resources.push(r);
        });
    },

    copyApplications() {

      return this.applications
        .filter(a => a.id !== null)
        .map(a => ({ ...a }));
    },

    getStatusService(status) {
      if (status > 0) {
        status = this.$store.state.statusServices.filter(function(select_item) {
          return select_item.id === status;
        })
        return status[0];
      }
    },

    getStatusClient(id) {
      return this.$store.state.statusClients.filter((select_item) => {
            return select_item.id === id;
          })[0];
    },

    async sentWelcomeEmail(addPaymentInfo) {
      console.log('sentWelcomeEmail', this.school_welcome_email);
      let payload = {};
      let emailIntro = '';
      if (this.school_welcome_email === 'english') {
        emailIntro = "<strong>¡Bienvenido a Proyecto Perú Inglés " + this.updatedClient.full_name + "!</strong> \n\n\n"
        emailIntro += "<strong>Normas y Protocolos</strong> \n\n"
        emailIntro += "Estamos muy emocionados de tenerte con nosotros y confiamos en que disfrutarás de esta experiencia de aprendizaje. " + 
        "Nuestro objetivo es apoyarte en tu camino hacia la fluidez en inglés, asegurándonos de que aproveches al máximo cada clase. " + 
        "Si tienes alguna pregunta o inquietud, no dudes en ponerte en contacto con nosotros. ¡Nos vemos en clase! \n\n"
        emailIntro += "<strong>RESPONSABILIDADES Y EXPECTATIVAS</strong> \n"
        emailIntro += "<ol type='1'>"
        emailIntro += "<li>Si el ESTUDIANTE llega tarde, el profesor esperará al ESTUDIANTE solo 20 minutos. " +
        "Si el ESTUDIANTE llega más de 20 minutos tarde sin haber contactado a PPI o simplemente no se presenta a la clase sin aviso previo, el ESTUDIANTE perderá la clase.</li>"
        emailIntro += "<li>Si el ESTUDIANTE necesita cancelar o reprogramar una clase programada, el ESTUDIANTE se compromete a contactar a PPI al menos 24 horas antes para reprogramar su clase. " + 
        "El ESTUDIANTE puede contactar directamente a PPI al (+51 941 111 085). Si la cancelación ocurre con menos de 24 horas de antelación o si el ESTUDIANTE no asiste a la clase, el ESTUDIANTE perderá la lección.</li>"
        emailIntro += "<li>Al elegir el paquete de grupo, debes seleccionar un horario y días fijos. Una vez elegido, debes comprometerte a asistir esos días y horas todas las semanas. " + 
        "Los paquetes de grupo no son flexibles, por lo que no se pueden cambiar los horarios una vez establecidos.</li>"
        emailIntro += "</ol>"
        emailIntro += "<strong>OBJETIVOS Y MÉTODO DE ENSEÑANZA</strong> \n"
        emailIntro += "<ol type='1'>"
        emailIntro += "<li><strong>Comunicación:</strong> " +
        "Fomentamos la comunicación abierta. Si tienes dudas sobre el contenido del curso o necesitas ayuda, habla con tu profesor durante la clase o envía un mensaje a PPI.</li>"
        emailIntro += "<li><strong>Participación:</strong> " +
        "La participación activa en clase es esencial para el aprendizaje. Se alienta a los ESTUDIANTES a hacer preguntas y compartir sus experiencias para enriquecer la experiencia de aprendizaje grupal.</li>"
        emailIntro += "<li><strong>Asistencia:</strong> " +
        "La asistencia regular es crucial para el progreso. Si un ESTUDIANTE tiene dificultades para asistir a las clases, debe contactar al profesor o al equipo de PPI para discutir opciones.</li>"
        emailIntro += "<li><strong>Código de Conducta:</strong> " +
        "Se espera que todos los ESTUDIANTES mantengan una actitud respetuosa hacia el profesor y los compañeros. Esto crea un ambiente de aprendizaje positivo y productivo.</li>"
        emailIntro += "</ol>"
        emailIntro += "<strong>Información de Cuenta:</strong> \n\n"
        emailIntro += "Nombre: Proyecto Perú Centre\n"
        emailIntro += "Cuenta BCP (Soles): 2852239009038\n"
        emailIntro += "Cuenta Interbank: 0022850022390090385\n\n"
        emailIntro += "¡Avísame si necesitas algún ajuste adicional o ayuda! \n\n"
        payload = {
            submittedFrom: "WecomeEmail",
            emailList: this.updatedClient.email,
            emailSubject: "¡Bienvenido a Proyecto Perú Inglés!",
            emailIntro: emailIntro,
            messageHTML: '',
            messagePlain: '',
            openEmailDialog: true,
            saveInvoice: false,
            attachments: '',
        };
      } else {
        let organisation = 'Proyecto Peru';
        if (this.updatedClient.agency_id) {
          organisation = this.updatedClient.agency
        }
        let medical = this.resources.filter(function(select_item) {
          return select_item.category_id === 2;
        })
        let accommodation = this.resources.filter(function(select_item) {
          return select_item.type_id === 4;
        })
        // HTML version 
        if (organisation === 'Proyecto Peru') {
          emailIntro = "Hi " + this.updatedClient.full_name + ",\n\n" + "We are excited to hear that you have decided to join Proyecto Peru! My name is " + this.$store.state.user + " and I will be helping to organize everything for you. " + 
          "We have received your application and are reviewing it carefully to ensure that we select the most appropriate placement and accommodation home-stay for you. \n\n"
          if (addPaymentInfo) {
            emailIntro += "We have also received your deposit of $... . The remainder of $... needs to be paid during the first three days of your services preferably in cash at our office in USD or Soles.\n\n"
          }
          emailIntro += "In the meantime, could you please complete our <Spanish Placement Test>, if you haven't done so already. This will help us to find the best placement for you. " + 
          "You can take Spanish classes while you do your program or online before you get to Cusco, just let us know. \n\n" + 
          "You will receive further details from us (via email) one month prior to your arrival with more information about your placement and home-stay. \n\n"
        } else {
          emailIntro = "Hi " + this.updatedClient.full_name + ",\n\n" + "It’s great to hear you’ve made the decision to join " + organisation + " and we're happy that you have chosen to join our program here in Cusco, Peru. My name is " + this.$store.state.user + " and I work with the Proyecto Peru team. \n" + 
          "We will be responsible for you during your stay here in Cusco, Peru and we look forward to hosting and supporting you. \n\n" +
          "We have received your application and are reviewing it carefully to ensure that we can select the most appropriate placement and accommodation home-stay for you. \n\n" + 
          "In the meantime, could you please complete our <Spanish Placement Test>, if you haven't done so already. This will help us to find the best placement for you. " + 
          "You can take Spanish classes while you do your program or online before you get to Cusco, just let us know. \n\n" + 
          "You will receive further details from us (via email) one month prior to your arrival with more information about your placement and home-stay. \n\n"
        }

        let counter = 0;
        if (accommodation.length > 0) {
          accommodation.sort(this.dynamicSort('start'));
          for (let index = 0; index < accommodation.length; index++) {
            if (accommodation[index].start && accommodation[index].end && accommodation[index].statusResourceId < 8) {
              if (counter === 0) {
                emailIntro += "Your accommodation is covered from "
              } else {
                emailIntro += ", "
              }
              emailIntro += this.formattedDate(accommodation[index].start) + " until " + this.formattedDate(accommodation[index].end) 
              counter = counter + 1;
            }
          }
        }

        if (counter === 0) {
          emailIntro += "You have not made reservations for any accommodation with us yet. "
        } else {
          emailIntro += ". "
        }

        emailIntro += "Should you need additional accommodation before or after your stay, please let us know as soon as possible, so that we can check availability and confirm the price of extra nights. \n\n"
        if (medical.length > 0) {
          emailIntro += "You are going to follow one of our medical programs placed with a medical clinic or healthcare institution which require you to use Personal Protective Equipment (PPE). " +
          "This includes a surgery gown and a bouffant cap. You have to wear these over your normal scrubs (any color scrubs). You may choose to bring your own PPE gear (scrubs, surgery gown and bouffant cap) or you can buy them in a shop in Cusco. " + 
          "We additionally provide interns with the opportunity to purchase the PPE from us during the orientation. We have secured an economic cost, which is US$3 per surgery gown and US$0.25 for the bouffant cap. " + 
          "If you don’t have scrubs, they can be purchased in Cusco for approx. US$10. Please advise us in advance if you would like to purchase the PPE gear from the team in Cusco. " + 
          "We can then ensure that the gear is delegated to you at the orientation. You can pay for the PPE then, in cash (in either USD or Peruvian Sol). \n\n"
        }

        emailIntro += "If you would like to arrange any tours during the weekends, we can help you book them with our partner agencies. " + 
        "Machu Picchu tickets sometimes sell out very quickly so we recommend booking this tour before your arrival. Just let us know and we can help you arrange it. We will need a copy of your passport if you book any tours. " +
        "Click <information on tours> for more information. \n\n" 

        if (this.updatedClient.agency_id === 2) {
          emailIntro += "Please continue to direct any questions about your upcoming program to Dallas at Intern Abroad HQ, as she remains your primary point of contact before you arrive in Cusco. \n\n"
        }

        if (organisation === 'Proyecto Peru') {
          emailIntro += "Please fill our <Application Form> if you haven't done so already.\n\n"
        }

        emailIntro += "Once again, thank you for choosing " + organisation + "’s program. We look forward to meeting you soon! \n\n" +
        "Kind regards, \n" + 
        this.$store.state.user + "\n\n" + 
        "info@proyectoperucentre.org\n" +
        "Proyecto Peru Centre\n" +
        "Avenida Arcopata 466-A\n" +
        "Cusco, Cusco, 45\n" +
        "+ 51 84 240 278"
        
        emailIntro += "\n\n--------------------------------------------------------------------\n\n";

        if (organisation === 'Proyecto Peru') {
          emailIntro += "Hola " + this.updatedClient.full_name + ",\n\n" +
            "¡Nos alegra mucho saber que has decidido unirte a Proyecto Peru! Mi nombre es " + this.$store.state.user + " y estaré encantado(a) de ayudarte a organizar todo para tu llegada. " +
            "Hemos recibido tu solicitud y la estamos revisando cuidadosamente para asegurarnos de seleccionar el programa y el alojamiento más adecuados para ti. \n\n";

          if (addPaymentInfo) {
            emailIntro += "También hemos recibido tu depósito de $... . El saldo restante de $... deberá abonarse durante los tres primeros días de tu programa, preferiblemente en efectivo en nuestra oficina, ya sea en dólares estadounidenses (USD) o soles peruanos.\n\n";
          }

          emailIntro += "Mientras tanto, si aún no lo has hecho, por favor completa nuestro <Spanish Placement Test>. Esto nos ayudará a encontrar el programa más adecuado para ti. " +
            "Puedes tomar clases de español durante tu programa o en línea antes de llegar a Cusco; solo tienes que avisarnos. \n\n" +
            "Un mes antes de tu llegada recibirás más información por correo electrónico, incluyendo los detalles sobre tu programa y tu alojamiento. \n\n";
        } else {
          emailIntro += "Hola " + this.updatedClient.full_name + ",\n\n" +
            "Nos alegra mucho saber que has decidido unirte a " + organisation + " y estamos muy contentos de que hayas elegido participar en nuestro programa aquí en Cusco, Perú. Mi nombre es " + this.$store.state.user + " y formo parte del equipo de Proyecto Peru. \n" +
            "Seremos responsables de apoyarte durante tu estancia en Cusco, Perú, y esperamos darte una cálida bienvenida y brindarte todo el apoyo que necesites. \n\n" +
            "Hemos recibido tu solicitud y la estamos revisando cuidadosamente para asegurarnos de seleccionar el programa y el alojamiento más adecuados para ti. \n\n" +
            "Mientras tanto, si aún no lo has hecho, por favor completa nuestro <Spanish Placement Test>. Esto nos ayudará a encontrar el programa más adecuado para ti. " +
            "Puedes tomar clases de español durante tu programa o en línea antes de llegar a Cusco; solo tienes que avisarnos. \n\n" +
            "Un mes antes de tu llegada recibirás más información por correo electrónico, incluyendo los detalles sobre tu programa y tu alojamiento. \n\n";
        }

        counter = 0;
        if (accommodation.length > 0) {
          accommodation.sort(this.dynamicSort('start'));
          for (let index = 0; index < accommodation.length; index++) {
            if (accommodation[index].start && accommodation[index].end && accommodation[index].statusResourceId < 8) {
              if (counter === 0) {
                emailIntro += "Tu alojamiento está reservado desde "
              } else {
                emailIntro += ", "
              }
              emailIntro += this.formattedDate(accommodation[index].start) + " hasta " + this.formattedDate(accommodation[index].end)
              counter = counter + 1;
            }
          }
        }

        if (counter === 0) {
          emailIntro += "Aún no has realizado ninguna reserva de alojamiento con nosotros. "
        } else {
          emailIntro += ". "
        }

        emailIntro += "Si necesitas alojamiento adicional antes o después de tu estancia, por favor háznoslo saber lo antes posible para que podamos comprobar la disponibilidad y confirmar el precio de las noches adicionales. \n\n"

        if (medical.length > 0) {
          emailIntro += "Vas a participar en uno de nuestros programas médicos, que se desarrolla en una clínica o institución sanitaria donde es obligatorio utilizar Equipo de Protección Personal (EPP). " +
          "Esto incluye una bata quirúrgica y un gorro quirúrgico desechable. Deberás utilizarlos sobre tu uniforme médico (scrubs de cualquier color). Puedes traer tu propio equipo de protección (scrubs, bata quirúrgica y gorro) o comprarlos en una tienda en Cusco. " +
          "También ofrecemos a nuestros estudiantes la posibilidad de adquirir este material durante la orientación. Hemos conseguido un precio económico de US$3 por cada bata quirúrgica y US$0.25 por cada gorro quirúrgico. " +
          "Si no dispones de scrubs, puedes comprarlos en Cusco por aproximadamente US$10. Por favor, avísanos con antelación si deseas adquirir el equipo de protección a través de nuestro equipo en Cusco. " +
          "De esta manera podremos tenerlo preparado para entregártelo durante la orientación. El pago podrá realizarse ese mismo día en efectivo, ya sea en dólares estadounidenses (USD) o soles peruanos. \n\n"
        }

        emailIntro += "Si deseas organizar alguna excursión durante los fines de semana, estaremos encantados de ayudarte a reservarla con nuestras agencias colaboradoras. " +
        "Las entradas para Machu Picchu suelen agotarse con mucha antelación, por lo que te recomendamos reservar este tour antes de tu llegada. Solo tienes que avisarnos y estaremos encantados de ayudarte a organizarlo. Necesitaremos una copia de tu pasaporte si reservas cualquier excursión. " +
        "Haz clic en <information on tours> para obtener más información. \n\n"

        if (this.updatedClient.agency_id === 2) {
          emailIntro += "Por favor, continúa dirigiendo cualquier consulta sobre tu próximo programa a Dallas de Intern Abroad HQ, ya que seguirá siendo tu principal punto de contacto hasta tu llegada a Cusco. \n\n"
        }

        if (organisation === 'Proyecto Peru') {
          emailIntro += "Por favor, completa nuestro <Application Form> si aún no lo has hecho.\n\n"
        }

        emailIntro += "Una vez más, gracias por elegir el programa de " + organisation + ". ¡Estamos deseando conocerte muy pronto! \n\n" +
        "Un cordial saludo,\n" +
        this.$store.state.user + "\n\n" +
        "info@proyectoperucentre.org\n" +
        "Proyecto Peru Centre\n" +
        "Avenida Arcopata 466-A\n" +
        "Cusco, Cusco, 45\n" +
        "+ 51 84 240 278"

        let attachments = '';
        if (this.updatedClient.includeHandbook) {
          attachments = 'handbook';
          this.updatedClient.handbookSent = this.formattedDate(new Date(), 'date');
        }

        payload = {
            submittedFrom: "WecomeEmail",
            emailList: this.updatedClient.email,
            emailSubject: "Welcome at Proyecto Peru",
            emailIntro: emailIntro,
            messageHTML: '',
            messagePlain: '',
            openEmailDialog: true,
            saveInvoice: false,
            attachments: attachments,
        };
      }
      this.updatedClient.welcome_email = this.formattedDate(new Date(), 'date');
      this.saveClient();
      await this.$store.dispatch('emailMessage', payload);
    },

    async sentThankYouEmail () {
      // HTML version
      let emailIntro = "Hola " + this.updatedClient.first_name + ",\n\n" + "On behalf of the Proyecto Peru staff, we would like to thank you for being a part of our family! " + 
      "We hope you enjoyed your time here in Cusco and accomplished what you set out to do. \n\n" + 
      "We consider all of our students an integral part of our success and while we are sad for you to leave this beautiful city of Cusco, we are happy for your next adventure and hope you will keep in touch. " + 
      "We are proud to have a very diverse group of students and volunteers and we hope that you made lifelong friends during your time with us. \n\n"
      if (this.updatedClient.agency_id === null) {
        emailIntro = emailIntro + "At your earliest convenience, we would appreciate your help in writing a review on <google>. "
      }
      emailIntro = emailIntro + "Any comments would be greatly appreciated. We are continually looking for ways to improve and give our students the best possible experience. \n" + 
      "If you have any other concerns or comments, please feel free to email us directly as well and please do not be a stranger! Stop by the office anytime and say hello whenever you decide to come back to Cusco. \n\n" +
      "Check out our <online classes> to keep your Spanish up to date with your favorite teacher!\n\n" +
      "Hasta la proxima y cuídate, \n\n The Proyecto Peru Team, \n" + 
      "info@proyectoperucentre.org\n" +
      "Proyecto Peru Centre\n" +
      "Avenida Arcopata 466-A\n" +
      "Cusco, Cusco, 45\n" +
      "+ 51 950 301 314"
      let payload = {
          submittedFrom: "ThankYouEmail",
          emailList: this.updatedClient.email,
          emailSubject: "Thank you " + this.updatedClient.first_name,
          emailIntro: emailIntro,
          messageHTML: '',
          messagePlain: '',
          saveInvoice: false,
          openEmailDialog: true,
          attachments: null,
      };
      this.updatedClient.thank_you_email = this.formattedDate(new Date(), 'date');
      this.saveClient();
      await this.$store.dispatch('emailMessage', payload);
    },

    goTeaching(resourceId) {
      this.$router.push({ name: 'Teaching', params: { resourceId: resourceId } })
    },

    goTour(resourceId) {
      this.$router.push({ name: 'TourAgencies', params: { resourceId: resourceId } })
    },

    goProject(resourceId) {
      this.$router.push({ name: 'ProjectPlacements', params: { resourceId: resourceId } })
    },

    goAccommodation(resourceId) {
      this.$router.push({ name: 'Accommodation', params: { resourceId: resourceId } })
    },

    async cancelClient() {
      for (let i = 0; i < this.applications.length; i++) {
        if (this.applications[i].amountOfClients === 1) {
          await this.$store.dispatch('deleteApplication', this.applications[i].id);
          await this.$store.dispatch('deleteApplicationPM', this.applications[i].id);
        }
      }
      this.updatedClient.statusFixed = 8;
      await this.saveClient();
      await this.initialize(this.updatedClient.id);
      this.$store.dispatch('successMessage', 'Client Cancelled');
    },

    async contactNoResponse() {
      if (Math.min.apply(Math, this.resources.map(function(o) { return o.statusResourceId; })) < 5) {
        this.$store.dispatch('errorMessage', 'Some resources appear to be planned. Remove them first please.');
      } else {
        this.updatedClient.statusFixed = 9;
        await this.saveClient();
        // await this.initialize(this.updatedClient.id);
        this.$store.dispatch('successMessage', 'Contact moved to status no response');
      }
    },

    async resetStatusClient() {
      this.updatedClient.statusFixed = 0;
      await this.saveClient();
      this.$store.dispatch('successMessage', 'Reset done');
    },

    async goFinancial(item) {
        // console.log("goFinancial", item);
        if (item === 'add') {
            this.$router.push({ name: 'Financial', params: { securityDeposit: 'add', clientId: this.updatedClient.id, incomeType: 26 } })
        } else if (item === 'remove') {
            this.$router.push({ name: 'Financial', params: { securityDeposit: 'remove', clientId: this.updatedClient.id, outgoingType: 79 } })
        } else if (item.income_id) {
            console.log('goFinancial transaction');
            this.$router.push({ name: 'Financial', params: { income_id: item.income_id, paidOn: item.paidOn } })
        } else {
            console.log('goFinancial outgoing');
            this.$router.push({ name: 'Financial', params: { outgoing_id: item.id, paidOn: item.paidOn } })
        }
    },

    getProjectCategory(categoryId) {
      if(this.$store.state.projectCategories.length > 0) {
        return this.$store.state.projectCategories.filter(function(select_item) {
          return select_item.id === categoryId;
        })[0].name;
      } else {
        return [];
      }
    },

    getProjectName(projectId) {
      if(this.$store.state.projects.length > 0) {
        return this.$store.state.projects.filter(function(select_item) {
          return select_item.id === projectId;
        })[0].name;
      } else {
        return [];
      }
    },

    getTour(tourId) {
      if(this.tourSelect.length > 0) {
        return this.tourSelect.filter(function(select_item) {
          return select_item.id === tourId;
        })[0];
      } else {
        return [];
      }
    },

    editResource(resource) {
      if (resource.family || resource.family == 1) {
        resource.family = "1"
      } else {
        resource.family = "0"
      }
      this.updatedResource = Object.assign({}, resource);
      this.updatedResourceStart = this.updatedResource.start;
      this.updatedResourceEnd = this.updatedResource.end;
      this.updatedResource.businessWeeks = this.getBusinessWeeks(this.updatedResource);
      this.dialogResource = true;
    },

    async saveResource () {
      this.$store.dispatch('setLoadingApp', 1);
      console.log('saveResource', this.updatedResource);
      await this.insertUpdateResource(this.updatedResource);
      this.updatedResource = {};
      this.$store.dispatch('setLoadingApp', 0);
    },

    editService(service) {
      console.log('editService', service);
      this.updatedService = JSON.parse(JSON.stringify(service));
      this.updatedServiceStart = this.updatedService.start;
      this.updatedServiceEnd = this.updatedService.end;
      let pos = null;
      pos = this.applications.map(function(e) { return e.id; }).indexOf(this.updatedService.application_id);
      if (pos !== -1) {
        if (this.applications[pos].frozen) {
          this.updatedService.frozen = true;
        }
      }
      this.dialogService = true;
    },

    async saveService() {
      console.log('saveService', this.updatedService);
      this.$store.dispatch('setLoadingApp', 1);

      let payload = {
        client: null,
        applications: null,
        services: [],
        radioGroups: [],
        radioOptions: [],
        options: [],
        resources: null,
      };

      let pos = null;
      pos = this.services.map(function(e) { return e.id; }).indexOf(this.updatedService.id);
      this.updatedService.last_changed_by = this.$store.state.uid;
      this.services[pos] = this.updatedService;
      payload.services.push(this.updatedService);

      let radioGroupSelected = this.updatedRadioGroups_filtered(this.updatedService.id);

      for (let i = 0; i < radioGroupSelected.length; i++) {
        let radioGroupSelectedPush = JSON.parse(JSON.stringify(radioGroupSelected[i]));
        payload.radioGroups.push(radioGroupSelectedPush);
      }

      let optionsSelected = this.updatedOptions_filtered(this.updatedService.id);

      for (let i = 0; i < optionsSelected.length; i++) {
        let optionsSelectedPush = JSON.parse(JSON.stringify(optionsSelected[i]));
        payload.options.push(optionsSelectedPush);
      }

      this.updatedService = [];
      
      let result = await this.$store.dispatch('insertUpdateMainItems', payload);
      
      if (result) {
        result = result.data;
        console.log('saveService #2', result);
        await this.updateAllItemsPresent(result);
      }

      this.$store.dispatch('setLoadingApp', 0);
      this.dialogService = false;
    },

    updatedRadioGroups_filtered(serviceId) {
      let filter = this.updatedRadioGroups.filter(function(item) {
          return item.services_id === serviceId;
        });
      if (filter && filter.length > 0) {
        return filter;
      }
      return [];
    },

    radioOptions_filtered (radioGroup) {
      let radioGroupId = radioGroup.radio_group_id;
      let servicesId = radioGroup.services_id;
      let arrayRadioOptions = this.updatedRadioOptions.filter(function(item) {
          return item.radio_group_id === radioGroupId && item.services_id === servicesId;
      });
      if (arrayRadioOptions && arrayRadioOptions.length > 0) {
        arrayRadioOptions.sort(this.dynamicSort('id'));
        return arrayRadioOptions;
      }
      return [];
    },

    updatedOptions_filtered(serviceId) {
      let filter = this.updatedOptions.filter(function(item) {
        return item.services_id === serviceId;
      });
      if (filter && filter.length > 0) {
        return filter;
      }
      return [];
    },

    openDialogEditClientBasic() {
      this.editClient = Object.assign({}, this.updatedClient);
      this.dialogEditClientBasic = true;
    },   

    checkBoolean (boolean) {
      if (boolean) {
        if (boolean === 1) {
          return true;
        }
      }
      return false;
    },

    async scrollTo(id) {
      console.log(id);
      const element = await this.waitForElement(id);
      console.log(id, element);
      id = '#' + id;
      this.$vuetify.goTo(id);
    },

    async waitForElement(selector) {
      while (!document.getElementById(selector)) {
        await new Promise(resolve => requestAnimationFrame(resolve));
      }
      return document.getElementById(selector);
    },

    filterServices(appId) {
      return this.services.filter(function(item) {
          return item.application_id === appId;
        }
      )
    },

    filterResources(serviceId) {
      return this.resources.filter(function(item) {
          return item.service_id === serviceId;
        }
      )
    },

    copyDatesFromService() {
      let resourceId = this.updatedResource.service_id;
      this.updatedResource.start = this.services.filter(function(item) {
          return item.id === resourceId;
        }, this
      )[0].start;
      this.updatedResource.end = this.services.filter(function(item) {
          return item.id === resourceId;
        }, this
      )[0].end;
      this.updatedResourceStart = this.updatedResource.start;
      this.updatedResourceEnd = this.updatedResource.end;
    },

    getListOfServicesTypes() {
      let types = [];
      for (let index = 0; index < this.$store.state.types.length; index++) {
        if (this.$store.state.types[index].orderTypes > 0) {
          types.push(this.$store.state.types[index]);
        }
      }
      return types;
    },

    async changeSynchronise(event, application) {
        application.syncPM = event;
        let pos = null;
        pos = this.applications.map(function(e) { return e.id; }).indexOf(application.id);
        this.applications[pos].syncPM = event;
        this.saveApplication(application);
    },

    async passToPlanning (event, application) {
        application.pass_to_planning = event;
        let pos = null;
        pos = this.applications.map(function(e) { return e.id; }).indexOf(application.id);
        this.applications[pos].pass_to_planning = event;
        await this.saveApplication(application);
        // this.resources = await this.$store.dispatch('getResourcesClientId', this.updatedClient.id);
    },


    // updateFreezeApplication (event, application) {
    //     console.log('updateFreezeApplication', event, application);
    //     application.frozen = event;
    //     let pos = null;
    //     pos = this.applications.map(function(e) { return e.id; }).indexOf(application.id);
    //     this.applications[pos].frozen = event;
    //     this.saveApplication(application);
    // },

    async saveApplication (application) {
        console.log("saveApplication", application);

        var date = new Date();
        let start = date.getTime();
        console.log('saveApplication ***1');

        let payload = {
          client: null,
          applications: [],
          services: null,
          radioGroups: null,
          radioOptions: null,
          options: null,
          resources: null,
        };

        payload.applications.push(application);
        let result = await this.$store.dispatch('insertUpdateMainItems', payload);
        // await this.getApplicationsClientId(this.updatedClient.id);
        
        if (result) {
          result = result.data;
          console.log('saveApplication #1', result);
          this.updateAllItemsPresent(result);
        }

        date = new Date();
        let end = date.getTime();
        let totalTime = ((end-start)/1000);
        console.log('saveApplication ***2', totalTime);

    },

    async updateAllItemsPresent(result) {
      console.log('updateAllItemsPresent', result);

      if (!result) {
        return;
      }

      this.client = await this.$store.dispatch('getClientId', this.updatedClient.id);
      this.updatedClient = JSON.parse(JSON.stringify(this.client));

      console.log('updateAllItemsPresent #1', this.updatedClient);

      let applicationsChanged = result.applications;
      for (let index = 0; index < applicationsChanged.length; index++) {
        let posApp = this.applications.map(function(e) { return e.id; }).indexOf(applicationsChanged[index].id);
        // console.log('saveApplication #2', posApp);
        if (posApp > -1) {
          // console.log('saveApplication #3');

          if (applicationsChanged[index].autoAppTitle === 1) {
            applicationsChanged[index].autoAppTitle = true;
          } else if (applicationsChanged[index].autoAppTitle === 0) {
            applicationsChanged[index].autoAppTitle = false;
          }
          if (applicationsChanged[index].pass_to_planning === 1) {
            applicationsChanged[index].pass_to_planning = true;
          } else if (applicationsChanged[index].pass_to_planning === 0) {
            applicationsChanged[index].pass_to_planning = false;
          }
          if (applicationsChanged[index].frozen === 1) {
            applicationsChanged[index].frozen = true;
          } else if (applicationsChanged[index].frozen === 0) {
            applicationsChanged[index].frozen = false;
          }
          if (applicationsChanged[index].syncPM === 1) {
            applicationsChanged[index].syncPM = true;
          } else if (applicationsChanged[index].syncPM === 0) {
            applicationsChanged[index].syncPM = false;
          }
          if (applicationsChanged[index].transferFeeIncluded === 1) {
            applicationsChanged[index].transferFeeIncluded = true;
          } else if (applicationsChanged[index].transferFeeIncluded === 0) {
            applicationsChanged[index].transferFeeIncluded = false;
          }
          if (applicationsChanged[index].depositPaid === 1) {
            applicationsChanged[index].depositPaid = true;
          } else if (applicationsChanged[index].depositPaid === 0) {
            applicationsChanged[index].depositPaid = false;
          }
          if (applicationsChanged[index].applicationNotPaid === 1) {
            applicationsChanged[index].applicationNotPaid = true;
          } else if (applicationsChanged[index].applicationNotPaid === 0) {
            applicationsChanged[index].applicationNotPaid = false;
          }

          this.applications[posApp] = JSON.parse(JSON.stringify(applicationsChanged[index]));
        }
      }
      this.applications.sort(this.dynamicSort('-id'));

      for (let index = 0; index < this.services.length; index++) {
        let posService = result.services.map(function(e) { return e.id; }).indexOf(this.services[index].id);
        if (posService > -1) {

          if (result.services[posService].handbookIncluded === 1) {
            result.services[posService].handbookIncluded = true;
          } else if (result.services[posService].handbookIncluded === 0) {
            result.services[posService].handbookIncluded = false;
          }

          this.services[index] = JSON.parse(JSON.stringify(result.services[posService]));
        }
      }

      for (let index = 0; index < this.resources.length; index++) {
        let posResource = result.resources.map(function(e) { return e.id; }).indexOf(this.resources[index].id);
        if (posResource > -1) {

          if (result.resources[posResource].family === 1) {
            result.resources[posResource].family = true;
          } else if (result.resources[posResource].family === 0) {
            result.resources[posResource].family = false;
          }
          if (result.resources[posResource].private_bathroom === 1) {
            result.resources[posResource].private_bathroom = true;
          } else if (result.resources[posResource].private_bathroom === 0) {
            result.resources[posResource].private_bathroom = false;
          }

          this.resources[index] = JSON.parse(JSON.stringify(result.resources[posResource]));
        }
      }

    },

    async displayApplication(application) {
      console.log('displayApplication', application);
      this.$store.dispatch('setLoadingApp', 1)
      application.clientId = this.updatedClient.id;
      await this.$store.dispatch('saveDataForReport', application);
      this.$store.dispatch('showApplication', true);
    },

    getResourceTypeName(resourceTypeId) {
      if (resourceTypeId === null) return '';
      return this.$store.state.types.filter(function(select_item) {
        return select_item.id === resourceTypeId;
      })[0].text;
    },

    appPlanned(appId) {
      const services = this.filterServices(appId) || [];
      return services.some(service => {
        const resources = this.filterResources(service.id) || [];
        // console.log('resources', JSON.parse(JSON.stringify(resources[0])));
        return resources.some(resource =>
            (resource?.minutes_planned != null && Number(resource.minutes_planned) > 0) ||
            resource?.placement_id ||
            resource?.room_id != null ||
            resource?.tour_placement_id != null
          );
        });
    },

    getBusinessWeeks (resource) {
      if (resource?.businessDays) {
        return this.decUtil.format(this.decUtil.toDec(resource.businessDays) / 5, 0)
      }
      return 0;
    },

    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text || '');
        this.$store.dispatch('successMessage', 'Copied to clipboard');
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    },

    passToPlanningColor(pass_to_planning) {
      if (pass_to_planning) {
        return "#688f69"
      } else {
        return "brown"
      }
    },

  },
}
</script>

<style>

.text-input-green .v-text-field__slot input {
    color: green !important;
    font-size: 1.2em;
}

.text-input-white .v-text-field__slot input {
    color: white !important;
    font-size: 1.2em;
}

.v-chip.Arrived {
  background: #35b729 !important;
}
.v-chip.Lead {
  background: grey !important;
}
.v-chip.Registering {
  background: #ff6285 !important;
}
/* 
.backgroundColorBlue {
  background-color: rgb(33, 150, 243);
} */

</style>